const basePath = '/questionnaire';

export const GENDER = Object.freeze({
  male: 'male',
  female: 'female',
  unknown: 'unknown'
});

export const GENDER_IDENTITY = Object.freeze({
  male: 'Male',
  female: 'Female',
  indeterminate: 'Indeterminate',
  male_AFAB: 'Male - AFAB',
  maleUAAB: 'Male - UAAB',
  female_AMAB: 'Female - AMAB',
  female_UAAB: 'Female - UAAB',
  nonbinary_genderr_diverse_AFAB: 'Non-binary/gender diverse - AFAB',
  nonbinary_gender_diverse_AMAB: 'Non-binary/gender diverse - AMAB',
  nonbinary_gender_diverse_UAAB: 'Non-binary/gender diverse - UAAB',
  unknown: 'Unknown/Not Stated'
});

export const FERTILITY = Object.freeze({
  infertile: 'infertile',
  fertile: 'fertile'
});

export const defaultPersonalDetailsValues = {
  firstName: {
    label: 'First Name',
    required: true,
    enabled: true,
    mandatory: true
  },
  lastName: {
    label: 'Last Name',
    required: true,
    enabled: true,
    mandatory: true
  },
  maidenName: {
    label: 'Maiden Name',
    required: false,
    enabled: true
  },
  // gender: {
  //   label: 'Sex Assigned at Birth',
  //   required: true,
  //   enabled: true,
  //   mandatory: true
  // },
  genderIdentity: {
    label: 'Gender',
    required: true,
    enabled: true,
    mandatory: true
  },
  selectDiagnoses: {
    label: 'Select Existing Diagnoses',
    required: false,
    enabled: true
  },
  comment: {
    label: 'Comments',
    required: false,
    enabled: true
  },
  pronouns: {
    label: 'Pronouns',
    required: false,
    enabled: true
  },
  dob: {
    label: 'Date of Birth',
    required: false,
    enabled: true
  },
  mobile: {
    label: 'Mobile',
    required: false,
    enabled: true
  },
  address_line1: {
    label: 'Address Line 1',
    required: false,
    enabled: true
  },
  address_line2: {
    label: 'Address Line 2',
    required: false,
    enabled: true
  },
  address_city: {
    label: 'City',
    required: false,
    enabled: true
  },
  address_country: {
    label: 'Country',
    required: false,
    enabled: true
  },
  address_state: {
    label: 'State / Province / Region',
    required: false,
    enabled: true
  },
  address_post: {
    label: 'Post code',
    required: false,
    enabled: true
  },
  gpName: {
    label: 'GP Name',
    required: false,
    enabled: true
  },
  gpAddress_line1: {
    label: 'GP Address Line 1',
    required: false,
    enabled: true
  },
  gpAddress_line2: {
    label: 'GP Address Line 2',
    required: false,
    enabled: true
  },
  gpAddress_city: {
    label: 'City',
    required: false,
    enabled: true
  },
  gpAddress_post: {
    label: 'Post code',
    required: false,
    enabled: true
  },
  gpAddress_country: {
    label: 'GP Country',
    required: false,
    enabled: true
  },
  healthcareId: {
    label: 'HealthcareID',
    required: false,
    enabled: true
  },
  pregnancy: {
    label: 'Have you ever been pregnant?',
    required: false,
    enabled: true
  },
  discloseIdentity: {
    label:
      'I am happy for you to disclose where you are calling from should someone other than myself answer the phone, and I consent to a message being left.',
    required: false,
    enabled: true
  },
  ethnicity: {
    label: 'Ethnicity',
    required: false,
    enabled: true
  },
  religion: {
    label: 'Religion',
    required: false,
    enabled: true
  }
};

export const defaultFamilyDetailsValues = {
  firstName: {
    label: 'First Name',
    required: true,
    enabled: true,
    mandatory: true
  },
  lastName: {
    label: 'Last Name',
    required: false,
    enabled: true
  },
  maidenName: {
    label: 'Maiden Name',
    required: false,
    enabled: true
  },
  dob: {
    label: 'Date of Birth',
    required: false,
    enabled: true
  },
  dod: {
    label: 'Date of Death',
    required: false,
    enabled: true
  },
  gender: {
    label: 'Sex Assigned at Birth',
    required: true,
    enabled: true,
    mandatory: true
  },
  genderIdentity: {
    label: 'Gender',
    required: false,
    enabled: true
  },
  yob: {
    label: 'Year of Birth',
    required: false,
    enabled: true
  },
  yod: {
    label: 'Year of Death',
    required: false,
    enabled: true
  },
  selectRelationship: {
    label: 'Select Relationship',
    required: true,
    enabled: true,
    mandatory: true
  },
  relationSide: {
    label: 'Which side of family?',
    required: false,
    enabled: true
  },
  relationDescribe: {
    label: 'Describe relation',
    required: false,
    enabled: true
  },
  haveTwin: {
    label: 'Does this family member have a twin?',
    required: false,
    enabled: true
  },
  twinMember: {
    label: 'Select twin member',
    required: false,
    enabled: true
  },
  twinType: {
    label: 'Twin type',
    required: false,
    enabled: true
  },
  selectParent: {
    label: 'Select Parent',
    required: true,
    enabled: true,
    mandatory: true
  },
  otherParentName: {
    label: "Other parent's name",
    required: false,
    enabled: true
  },
  spouseIsBioParent: {
    label: 'Is your current spouse the biological parent of this child?',
    required: true,
    enabled: true,
    mandatory: true
  },
  otherBioParent: {
    label: 'Who is the other biological parent of this child?',
    required: false,
    enabled: true
  },
  age: {
    label: 'Age',
    required: false,
    enabled: true
  },
  lastKnownAddress: {
    label: 'Last known address',
    required: false,
    enabled: true
  },
  selectDiagnoses: {
    label: 'Select Diagnoses',
    required: false,
    enabled: true
  },
  comment: {
    label: 'Comments',
    required: false,
    enabled: true
  }
};

export const defaultRiskSurveyValues = {
  isJewish: {
    label:
      'Some genetic disorders are slightly more common in Jewish families. Are you Jewish or do you have Jewish Ancestry?',
    required: false,
    enabled: true
  },
  isWomanCancer: {
    label: 'Are you a woman who has a history of breast or ovarian cancer?',
    required: false,
    enabled: true
  },
  majorIllness: {
    label:
      'Have you previously been diagnosed with or suspected of having any medical conditions?',
    required: false,
    enabled: true
  },
  mainGeneticsQuestions: {
    label:
      'What are your main questions that you would like to discuss with the genetics service?',
    required: false,
    enabled: true
  },
  riskCancer: {
    label:
      'What do you think your risk of developing this cancer is compared with someone in the general population?',
    required: false,
    enabled: true
  },
  chancesCancer: {
    label:
      'What do you think your chances are of developing this cancer in your lifetime?',
    required: false,
    enabled: true
  },
  height: {
    label: 'Height (cm):',
    required: false,
    enabled: true
  },
  height_inFoot: {
    label: 'Height (Feet)',
    required: false,
    enabled: true
  },
  height_inInches: {
    label: '(Inches)',
    required: false,
    enabled: true
  },
  weight: {
    label: 'Weight (kg):',
    required: false,
    enabled: true
  },
  weight_inPounds: {
    label: 'Pounds (lbs):',
    required: false,
    enabled: true
  },
  isDrinkAlcohol: {
    label: 'Do you drink alcohol?',
    required: false,
    enabled: true
  },
  averageAlcoholConsupmtions: {
    label: 'On average how many drinks do you have and how often?',
    required: false,
    enabled: true
  },
  isSmokeCigarettes: {
    label: 'Do you smoke cigarettes?',
    required: false,
    enabled: true
  },
  everSmokeCigarettes: {
    label: 'If no, have you ever smoked cigarettes?',
    required: false,
    enabled: true
  },
  ageFirstPeriod: {
    label: '"How old were you (roughly) when you had your first period?',
    required: false,
    enabled: true
  },
  isPeriodsStop: {
    label: 'Have your periods stopped?',
    required: false,
    enabled: true
  },
  agePeriodsStop: {
    label: 'If yes, how old were you (roughly) when they stopped?',
    required: false,
    enabled: true
  },
  isTakenOCP: {
    label: 'Have you taken the Oral Contraceptive Pill (OCP)?',
    required: false,
    enabled: true
  },
  numberYearsTakenOCP: {
    label: 'If yes, for how many years in total?',
    required: false,
    enabled: true
  },
  lastYearTakenOCP: {
    label: 'What year did you last take OCP?',
    required: false,
    enabled: true
  },
  isTakenHRT: {
    label: 'Have you taken hormonal replacement therapy (HRT)?',
    required: false,
    enabled: true
  },
  numberYearsTakenHRT: {
    label: 'If yes, for how many years in total?',
    required: false,
    enabled: true
  },
  lastYearTakenHRT: {
    label: 'What year did you last take HRT?',
    required: false,
    enabled: true
  },
  typeOfHRTTaken: {
    label: 'If yes, type of HRT (if known):',
    required: false,
    enabled: true
  },
  isMammogram: {
    label: 'Have you ever had a mammogram?',
    required: false,
    enabled: true
  },
  BIRADScategory: {
    label: 'If yes, do you know your BI-RADS (breast density) category?',
    required: false,
    enabled: true
  },
  isDiagnosedEndometriosis: {
    label: 'Have you been diagnosed with endometriosis?',
    required: false,
    enabled: true
  },
  isTubesTied: {
    label: 'Have you had your tubes tied (tubal ligation)?',
    required: false,
    enabled: true
  },
  isOvariesOrFallopianRemoved: {
    label: 'Have you had your ovaries and/or fallopian tubes removed?',
    required: false,
    enabled: true
  },
  typeOfOvariesOrFallopianRemoved: {
    label: 'If yes (please select):',
    required: false,
    enabled: true
  },
  isMastectomy: {
    label: 'Have you had both breasts removed (Mastectomy)?',
    required: false,
    enabled: true
  }
};

export const defaultPregnancyDetailsValues = {
  assitReproductiveTherapies: 'Assisted reproductive therapies, including IVF?',
  twins_triplets: 'Twins / triplets?',
  outcome: 'Outcome of Pregnancy',
  deliveryMode: 'Mode of delivery',
  doOutcome: 'Date of Outcome',
  completedWeeks: 'Completed weeks of pregnancy',
  complications:
    'Complications during pregnancy or delivery (select any that apply)',
  comments: 'Comments'
};

// make sure to update backend/util - if this is updated
export const relationshipMap = {
  son: 'Son',
  daughter: 'Daughter',
  fullSister: 'Full Sister',
  halfSister: 'Half Sister',
  fullBrother: 'Full Brother',
  halfBrother: 'Half Brother',
  spouse: 'Spouse',
  mother: 'Mother',
  father: 'Father',
  mothersMother: "Mother's Mother",
  mothersFather: "Mother's Father",
  fathersMother: "Father's Mother",
  fathersFather: "Father's Father",
  mothersBrother: "Mother's Brother",
  mothersSister: "Mother's Sister",
  fathersBrother: "Father's Brother",
  fathersSister: "Father's Sister",
  otherAffected: 'Other relative with disease/disorder',
  // TGCLOUD-1458. System-minted by the FHQ for a half-sibling's other parent.
  // Deliberately absent from `relationsOptions` — a patient must never be able to
  // pick a designation the system assigns. The XML wire string stays unchanged;
  // see the note on relationsMap in backend/util/constants.js.
  halfSiblingParent: "Half Sibling's Parent"
};
export const spouseRelations = Object.freeze({
  MARRIED: 'married',
  SEPARATED: 'separated',
  CASUAL: 'casual',
  DIVORCED: 'divorced'
});

export const relationshipGenderMap = {
  son: GENDER.male,
  daughter: GENDER.female,
  fullSister: GENDER.female,
  halfSister: GENDER.female,
  fullBrother: GENDER.male,
  halfBrother: GENDER.male,
  mother: GENDER.female,
  father: GENDER.male,
  mothersMother: GENDER.female,
  mothersFather: GENDER.male,
  fathersMother: GENDER.female,
  fathersFather: GENDER.male,
  mothersBrother: GENDER.male,
  mothersSister: GENDER.female,
  fathersBrother: GENDER.male,
  fathersSister: GENDER.female
};

export const diagnosesMap = {
  'breast-cancer': 'Breast Cancer',
  'pancreatic-cancer': 'Pancreatic Cancer',
  'endometrial-cancer': 'Endometrial (Uterus) cancer',
  'colon-cancer': 'Colon Cancer',
  'ovarian-cancer': 'Ovarian Cancer',
  'prostate-cancer': 'Prostate Cancer',
  polyps: 'Polyps',
  'heart-problems': 'Heart problems',
  'eye-problems': 'Eye problems',
  'kidney-problems': 'Kidney problems',
  'neurological-conditions': 'Neurological',
  other: 'Other',
  'blood-disorders': 'Blood Disorders',
  stillbirth: 'Stillbirth',
  'recurrent-misscarriage': 'Recurrent Miscarriage',
  'congenital-abnormalities': 'Congenital Abnormalities',
  hemophilia_a: 'Hemophilia A',
  hemophilia_b: 'Hemophilia B',
  fibrinogen_disorder: 'Fibrinogen Disorder',
  von_willebrand_disease: 'Von Willebrand Disease',
  glanzmann_thrombasthenia: 'Glanzmann Thrombasthenia',
  bernard_soulier_syndrome: 'Bernard Soulier Syndrome',
  hereditary_hemorrhagic_telangiectasia:
    'Hereditary Hemorrhagic Telangiectasia (HHT)',
  platelet_function_disorder: 'Platelet Function Disorder',
  neutropenia: 'Neutropenia',
  protein_c_deficiency: 'Protein C Deficiency',
  protein_s_deficiency: 'Protein S Deficiency',
  antithrombin_iii_deficiency: 'Antithrombin III Deficiency',
  factor_v_leiden: 'Factor V Leiden',
  prothrombin_gene_variant: 'Prothrombin Gene Variant',
  'low_platelet_count_(thrombocytopenia)':
    'Low Platelet Count (Thrombocytopenia)',
  'blood_clot_(thrombosis)': 'Blood Clot (Thrombosis)'
};

// Covers BOTH the Bennett values now stored (see pregnancyOutcomes) AND the legacy values
// (delivered/miscarriage/termination) still present on pre-existing FHQ submissions, so old
// and new records both render a label.
export const pregnancyOutcomeMap = {
  // Bennett
  ongoing: 'Ongoing',
  liveBirth: 'Live birth',
  sab: 'Miscarriage',
  ectopic: 'Ectopic pregnancy',
  stillbirth: 'Stillbirth',
  top: 'Termination',
  // legacy (pre-existing stored FHQ records)
  delivered: 'Live birth',
  miscarriage: 'Miscarriage',
  termination: 'Termination'
};

export const pregnancyDeliveryModeMap = {
  vaginal: 'Vaginal',
  cesarean: 'Cesarean',
  // The stored value is 'vacuum' (pregnancyDeliveryModesOptions). This map was keyed 'cacuum', so
  // the lookup missed and the delivery mode rendered BLANK everywhere it is displayed — the FHQ
  // table, the read-only submitted view, and the Desktop XML export, which emitted undefined.
  // The misspelling is kept as an alias in case any historical row was written with it.
  vacuum: 'Vacuum',
  cacuum: 'Vacuum',
  forceps: 'Forceps'
};

export const pregnancyComplicationsMap = {
  'pre-eclampsia': 'Pre-eclampsia',
  'gestational-hypertension': 'Gestational hypertension',
  'gestational-diabetes': 'Gestational diabetes',
  'post-partum-haemorrhage': 'Post-partum haemorrhage',
  'iron-deficiency-anemia': 'Iron-deficiency anemia',
  polyhydramnios: 'Polyhydramnios',
  other: 'Other'
};

export const alcoholFrequencyMap = {
  daily: 'daily',
  weekly: 'weekly',
  monthly: 'monthly'
};

export const tubesRemovedOptions = [
  { value: 'ovaries', label: 'Ovaries' },
  { value: 'fallopian', label: 'Fallopian tubes' },
  { value: 'both', label: 'Both' }
];

export const alcoholFrequencyOptions = [
  { label: 'Daily', value: 'daily' },
  { label: 'Weekly', value: 'weekly' },
  { label: 'Monthly', value: 'monthly' }
];

export const alcoholTypeLabelMap = {
  smallWine: 'Glass of Wine (175 ml)',
  beerPint: 'Pint of Beer / Lager / Cider (568 ml)',
  beerBottle: 'Bottle of Beer (Standard 330 ml)',
  alcoPop: 'Alcoholic Pop Drink (275 ml)',
  spirits:
    'Shot of spirits (25 ml) includes gin, rum, vodka, whisky, tequila, sambuca'
};

export const alcoholTypeUnitUKMap = {
  smallWine: 1.93,
  beerPint: 2.3,
  beerBottle: 1.65,
  alcoPop: 1.1,
  spirits: 1
};

export const alcoholTypeGramsUKMap = {
  smallWine: 15.4,
  beerPint: 18.4,
  beerBottle: 13.2,
  alcoPop: 8.8,
  spirits: 8.0
};

export const alcoholNumberDaysMap = {
  daily: 1,
  weekly: 7,
  monthly: 30
};

export const alcoholTypelMap = {
  smallWine: 'smallWine',
  beerPint: 'beerPint',
  beerBottle: 'beerBottle',
  alcoPop: 'alcoPop',
  spirits: 'spirits'
};

export const presetAlcoholConsumptionDetails = [
  {
    type: alcoholTypelMap.smallWine,
    frequency: '',
    amount: 0
  },
  {
    type: alcoholTypelMap.beerPint,
    frequency: '',
    amount: 0
  },
  {
    type: alcoholTypelMap.beerBottle,
    frequency: '',
    amount: 0
  },
  {
    type: alcoholTypelMap.alcoPop,
    frequency: '',
    amount: 0
  },
  {
    type: alcoholTypelMap.spirits,
    frequency: '',
    amount: 0
  }
];
export const linkParametersMap = {
  cardiac: 'Cardiac',
  cancer: 'Cancer',
  blood: 'Blood',
  general: 'General'
};

export const relationsOptions = [
  { label: 'Son', value: 'son' },
  { label: 'Daughter', value: 'daughter' },
  { label: 'Full Sister', value: 'fullSister' },
  { label: 'Half Sister', value: 'halfSister' },
  { label: 'Full Brother', value: 'fullBrother' },
  { label: 'Half Brother', value: 'halfBrother' },
  { label: 'Spouse', value: 'spouse' },
  { label: 'Mother', value: 'mother' },
  { label: 'Father', value: 'father' },
  { label: "Mother's Mother", value: 'mothersMother' },
  { label: "Mother's Father", value: 'mothersFather' },
  { label: "Father's Mother", value: 'fathersMother' },
  { label: "Father's Father", value: 'fathersFather' },
  { label: "Mother's Brother", value: 'mothersBrother' },
  { label: "Mother's Sister", value: 'mothersSister' },
  { label: "Father's Brother", value: 'fathersBrother' },
  { label: "Father's Sister", value: 'fathersSister' },
  { label: 'Other relative with disease/disorder', value: 'otherAffected' }
];

export const singeAddRelations = [
  'mother',
  'father',
  'mothersMother',
  'mothersFather',
  'fathersMother',
  'fathersFather'
];

export const womenGeneticData = [
  'isWomanCancer',
  'ageFirstPeriod',
  'isPeriodsStop',
  'agePeriodsStop',
  'isTakenOCP',
  'numberYearsTakenOCP',
  'lastYearTakenOCP',
  'isWomanCancer',
  'isTakenHRT',
  'numberYearsTakenHRT',
  'lastYearTakenHRT',
  'typeOfHRTTaken',
  'isMammogram',
  'BIRADScategory',
  'isDiagnosedEndometriosis',
  'isTubesTied',
  'isOvariesOrFallopianRemoved',
  'typeOfOvariesOrFallopianRemoved',
  'isMastectomy'
];

const RELATIONS = {
  children: 'children',
  siblings: 'siblings',
  halfSiblings: 'halfSiblings',
  mothersSibling: 'mothersSibling',
  fathersSibling: 'fathersSibling'
};

// map of all relations used to populate the twin options
export const relationMap = {
  self: RELATIONS.siblings,
  mother: RELATIONS.mothersSibling,
  father: RELATIONS.fathersSibling,
  son: RELATIONS.children,
  daughter: RELATIONS.children,
  fullSister: RELATIONS.siblings,
  fullBrother: RELATIONS.siblings,
  halfSister: RELATIONS.halfSiblings,
  halfBrother: RELATIONS.halfSiblings,
  mothersBrother: RELATIONS.mothersSibling,
  mothersSister: RELATIONS.mothersSibling,
  fathersBrother: RELATIONS.fathersSibling,
  fathersSister: RELATIONS.fathersSibling
};

export const allRelations = {
  mother: 'mother',
  father: 'father',
  mothersMother: 'mothersMother',
  mothersFather: 'mothersFather',
  fathersMother: 'fathersMother',
  fathersFather: 'fathersFather',
  fullSister: 'fullSister',
  fullBrother: 'fullBrother',
  halfSister: 'halfSister',
  halfBrother: 'halfBrother',
  daughter: 'daughter',
  son: 'son',
  mothersSister: 'mothersSister',
  mothersBrother: 'mothersBrother',
  fathersSister: 'fathersSister',
  fathersBrother: 'fathersBrother',
  spouse: 'spouse',
  otherAffected: 'otherAffected',
  halfSiblingParent: 'halfSiblingParent'
};

export const FAMILY_STRUCTURE_SECTIONS = [
  {
    toggleKey: 'isBrotherSister',
    question: 'Do you have any brothers or sisters?',
    counters: [
      {
        key: 'sisterCount',
        label: 'Sisters',
        relationship: allRelations.fullSister
      },
      {
        key: 'brotherCount',
        label: 'Brothers',
        relationship: allRelations.fullBrother
      },
      {
        key: 'halfSisterCount',
        label: 'Half sisters',
        relationship: allRelations.halfSister
      },
      {
        key: 'halfBrotherCount',
        label: 'Half brothers',
        relationship: allRelations.halfBrother
      }
    ]
  },
  {
    toggleKey: 'isSpouse',
    question: 'Do you have a spouse or partner?',
    counters: []
  },
  {
    toggleKey: 'isChildren',
    question: 'Do you have any biological children?',
    counters: [
      {
        key: 'daughterCount',
        label: 'Daughters',
        relationship: allRelations.daughter
      },
      { key: 'sonCount', label: 'Sons', relationship: allRelations.son }
    ]
  },
  {
    toggleKey: 'isMumBrotherSister',
    question: 'Does your mother have any brothers or sisters?',
    counters: [
      {
        key: 'mumSisterCount',
        label: 'Maternal aunts',
        relationship: allRelations.mothersSister
      },
      {
        key: 'mumBrotherCount',
        label: 'Maternal uncles',
        relationship: allRelations.mothersBrother
      }
    ]
  },
  {
    toggleKey: 'isDadBrotherSister',
    question: 'Does your father have any brothers or sisters?',
    counters: [
      {
        key: 'dadSisterCount',
        label: 'Paternal aunts',
        relationship: allRelations.fathersSister
      },
      {
        key: 'dadBrotherCount',
        label: 'Paternal uncles',
        relationship: allRelations.fathersBrother
      }
    ]
  },
  {
    toggleKey: 'isOtherRelative',
    question:
      'Are there other family members affected by a disorder or disease?',
    counters: [
      {
        key: 'otherRelativeCount',
        label: 'Number of relatives',
        relationship: allRelations.otherAffected
      }
    ]
  }
].map((section) => ({
  ...section,
  relationships: section.counters.length
    ? section.counters.map((c) => c.relationship)
    : [allRelations.spouse]
}));

export const CONSTANTS = Object.freeze({
  formPath: basePath,
  generateLinkPath: `${basePath}/generate-link`,
  title: 'Family History Enquiry Form',

  disclaimerLabel: 'Instructions',
  disclaimerPath: `${basePath}/instructions`,

  personalDetailsLabel: 'Personal Details',
  personalDetailsPath: `${basePath}/personal-details`,
  verifyLinkPath: `${basePath}/verify-link`,

  familyDetailsLabel: 'Family Details',
  familyDetailsPath: `${basePath}/family-details`,
  additionalFamilyDetailsPath: `${basePath}/additional-family-details`,

  pregnancyDetailsLabel: 'Pregnancy Details',
  pregnancyDetailsPath: `${basePath}/pregnancy-details`,

  // confirmDetailsLabel: 'Confirm Family Details',
  // confirmDetailsPath: `${basePath}/confirm-details`,

  geneticDetailsLabel: 'Risk Survey',
  geneticDetailsPath: `${basePath}/genetic-details`,

  reviewLabel: 'Review and Submit',
  reviewPath: `${basePath}/review`,

  customisationPath: `${basePath}/additional-questions`,

  saveNotif: 'Details saved',
  errorNotif: 'Error saving values, please try again',

  saveAndContinueLaterTitle: 'Save and Continue Later',
  saveAndContinueLaterButton: 'Save & Continue Later',
  distanceTopSaveAndReturnLaterDialog: 50,
  saveAndContinueLaterMessage:
    'Your data has been saved so you may safely close the browser.  To return to the FHQ later, simply click the link from your email again',

  yesNoOptions: [
    { value: 'true', label: 'Yes' },
    { value: 'false', label: 'No' }
  ],
  chancesCancerOptions: [
    { label: '0%', value: '0' },
    { label: '25%', value: '25' },
    { label: '50%', value: '50' },
    { label: '75%', value: '75' },
    { label: '100%', value: '100' }
  ],
  riskCancerOptions: [
    { label: 'Much Less', value: 'muchLess' },
    { label: 'Slightly Less', value: 'slightlyLess' },
    { label: 'Same As', value: 'sameAs' },
    { label: 'Slightly Higher', value: 'slightlyHigher' },
    { label: 'Much Higher', value: 'muchHigher' }
  ],
  otherRelationshipSideOptions: [
    { value: 'Maternal', label: 'Maternal' },
    { value: 'Paternal', label: 'Paternal' }
  ],

  genderOptions: [
    { value: 'female', label: 'Female' },
    { value: 'male', label: 'Male' },
    { value: 'unknown', label: 'Other' }
  ],

  pregnancyDeliveryModesOptions: [
    { label: 'Vaginal', value: 'vaginal' },
    { label: 'Cesarean', value: 'cesarean' },
    { label: 'Vacuum', value: 'vacuum' },
    { label: 'Forceps', value: 'forceps' }
  ],

  twinTypeOptions: [
    { label: 'Identical', value: 'identical' },
    { label: 'Non-Identical', value: 'non-identical' }
  ],

  halfRelation: ['halfSister', 'halfBrother'],
  twinRelation: ['fullSister', 'fullBrother'],
  nonTwinRelation: [
    'spouse',
    'mother',
    'father',
    'mothersMother',
    'mothersFather',
    'fathersMother',
    'fathersFather',
    'otherAffected',
    'halfSiblingParent'
  ],

  genderIdentityOptions: [
    { label: 'Male', value: 'Male' },
    { label: 'Female', value: 'Female' },
    { label: 'Indeterminate', value: 'Indeterminate' },
    { label: 'Male - Assigned Female at Birth', value: 'Male - AFAB' },
    {
      label: 'Male -  Unspecified/Unknown Assigned at Birth',
      value: 'Male - UAAB'
    },
    { label: 'Female - Assigned Male at Birth', value: 'Female - AMAB' },
    {
      label: 'Female - Unspecified/Unknown Assigned at Birth',
      value: 'Female - UAAB'
    },
    {
      label: 'Non-binary/gender diverse -  Assigned Female at Birth',
      value: 'Non-binary/gender diverse - AFAB'
    },
    {
      label: 'Non-binary/gender diverse - Assigned Male at Birth',
      value: 'Non-binary/gender diverse - AMAB'
    },
    {
      label:
        'Non-binary/gender diverse - Unspecified/Unknown Assigned at Birth',
      value: 'Non-binary/gender diverse - UAAB'
    },
    { label: 'Unknown/Not Stated', value: 'Unknown/Not Stated' }
  ],

  inheritanceModesOptions: [
    { label: 'Autosomal dominant', value: 'autosomal_dominant' },
    { label: 'Autosomal recessive', value: 'autosomal_recessive' },
    { label: 'X-linked dominant', value: 'x_linked_dominant' },
    { label: 'X-linked recessive', value: 'x_linked_recessive' },
    { label: 'X-linked', value: 'x_linked' },
    { label: 'Y-linked', value: 'y_linked' },
    { label: 'Codominant', value: 'codominant' },
    { label: 'Mitochondrial', value: 'mitochondrial' },
    { label: 'Sporadic', value: 'sporadic' },
    { label: 'Chromosomal', value: 'chromosomal' }
  ],

  spouseRelationshipOptions: [
    { label: 'Married', value: spouseRelations.MARRIED },
    { label: 'Separated', value: spouseRelations.SEPARATED },
    { label: 'Divorced', value: spouseRelations.DIVORCED },
    { label: 'Casual', value: spouseRelations.CASUAL }
  ],

  genderMappings: {
    Male: 'male',
    Female: 'female',
    Indeterminate: 'unknown',
    'Male - AFAB': 'female',
    'Male - UAAB': 'unknown',
    'Female - AMAB': 'male',
    'Female - UAAB': 'unknown',
    'Non-binary/gender diverse - AFAB': 'female',
    'Non-binary/gender diverse - AMAB': 'male',
    'Non-binary/gender diverse - UAAB': 'unknown',
    'Unknown/Not Stated': 'unknown'
  },

  generalDiagnoses: [
    'heart-problems',
    'eye-problems',
    'kidney-problems',
    'neurological-conditions',
    'other'
  ],
  diagnoses: [
    'breast-cancer',
    'pancreatic-cancer',
    'endometrial-cancer',
    'colon-cancer',
    'ovarian-cancer',
    'prostate-cancer',
    'polyps'
  ],
  pregnanciesDiagnoses: [
    'stillbirth',
    'recurrent-misscarriage',
    'congenital-abnormalities'
  ],
  bloodDiagnoses: [
    'blood-disorders',
    'hemophilia_a',
    'hemophilia_b',
    'fibrinogen_disorder',
    'von_willebrand_disease',
    'glanzmann_thrombasthenia',
    'bernard_soulier_syndrome',
    'hereditary_hemorrhagic_telangiectasia',
    'platelet_function_disorder',
    'neutropenia',
    'protein_c_deficiency',
    'protein_s_deficiency',
    'antithrombin_iii_deficiency',
    'factor_v_leiden',
    'prothrombin_gene_variant',
    'low_platelet_count_(thrombocytopenia)',
    'blood_clot_(thrombosis)'
  ],
  // Bennett-aligned outcome values with patient-friendly labels. Ongoing + Ectopic added so a
  // currently-pregnant respondent (and ectopic history) can be recorded. Stored values are the
  // Bennett enum; legacy records (delivered/miscarriage/termination) still read via
  // pregnancyOutcomeMap + the read-side normalizer.
  pregnancyOutcomes: [
    { label: 'Ongoing (currently pregnant)', value: 'ongoing' },
    { label: 'Live birth', value: 'liveBirth' },
    { label: 'Miscarriage', value: 'sab' },
    { label: 'Ectopic pregnancy', value: 'ectopic' },
    { label: 'Stillbirth', value: 'stillbirth' },
    { label: 'Termination', value: 'top' }
  ],

  pregnancyComplications: [
    'pre-eclampsia',
    'gestational-hypertension',
    'gestational-diabetes',
    'post-partum-haemorrhage',
    'iron-deficiency-anemia',
    'polyhydramnios',
    'other'
  ],

  alcoholLabelType: [
    'smallWine',
    'beerPint',
    'beerBottle',
    'alcoPop',
    'spirits'
  ],

  alcoholFrequency: ['daily', 'weekly', 'monthly'],

  linkParameters: ['cancer', 'cardiac', 'blood', 'general'],

  instructions:
    '<p>Please provide details of family members that have been affected by disease(s) or disorder(s) and those that have not. This is important in assessing your risk of inherited diseases and disorders.<br />' +
    '<p>Try to complete all sections, if some are not relevant then please put N/A for "not applicable".<br />' +
    '<p>Some  first  names  can  be  used  for  males  or  females,  or  are  unusual.  Please  could  you  put "Male" or "Female" in the appropriate column.<br />' +
    'The more details you provide, the more accurate your assessment can be.</p>',
  consentNotProvided: 'Limit value only without family member consent',

  defaultFamilyDetails: {
    // relationship: "",
    // gender: "",
    // firstName: "",
    // maidenName: "",
    // lastName: "",
    // halfParent: "",
    // twinMember: "",
    // twinType: "",
    // otherParent: "",
    // isAlive: "",
    // isTwin: "",
    // dob: null,
    // dod: null,
    diagnoses: [],
    // comments: "",
    // age: "",
    diagnosesAge: {},
    consent: {},
    estimatedDod: false,
    estimatedDob: false
  },

  defaultPregnancyDetails: {
    complications: []
  },

  initialContent: {
    validated: false,
    token: '',
    personalDetails: {
      // _id: null,
      // gender: '',
      // proBandId: '',
      // firstName: '',
      // lastName: '',
      // maidenName: '',
      // dob: null,
      // dod: null,
      // mobile: '',
      // address_line1: '',
      // address_line2: '',
      // address_city: '',
      // address_post: '',
      // address_state: '',
      // gpName: '',
      // gpAddress_line1: '',
      // gpAddress_line2: '',
      // gpAddress_city: '',
      // gpAddress_post: '',
      // discloseIdentity: '',
      // familyMembers: [],
      // // receiveLetter: '',
      // submitted: false
      estimatedDob: false,
      estimatedDod: false
    },
    familyAdditionalDetails: {},
    relations: relationsOptions,
    family: [],
    geneticDetails: {
      // _id: null,
      // isJewish: "",
      // isWomanCancer: "",
      // majorIllness: "",
      // riskCancer: "",
      // chancesCancer: "",
      // mainGeneticsQuestions: "",
    },
    bloodSpecialityDetails: {
      epistaxis: '0',
      cutaneous: '0',
      minorBleeding: '0',
      oralCavity: '0',
      giBleeding: '0',
      hematuria: '0',
      toothExtraction: '0',
      surgery: '0',
      menorrhagia: '0',
      hemorrhage: '0',
      hematomas: '0',
      hemarthrosis: '0',
      cnsBleeding: '0',
      otherBleeding: '0'
    },
    customTheme: {
      dateFormat: 'DD/MM/YYYY',
      appearance: {
        value: 'light',
        color: '#FFFF',
        shade: '#DDDDDD',
        text: '#000'
      },
      appbarHeight: 65,
      navbar: '#FFFFFF',
      navbarText: '#000',
      accent: '#2ba9bf',
      header: '#2ba9bf',
      buttonStyle: '#f50057',
      buttonText: '#FFFFFF'
    },
    customisation: {
      isEnabled: false,
      instructions: '<p></p>',
      defaultClinicianDiagnoses: '<p></p>',
      customConsent:
        '<strong>I am happy for you to disclose where you are calling from should someone other than myself answer the phone, and I consent to a message being left.</strong>',
      customAdditionalQuestionsInstructions: '<p></p>',
      customPersonalDetailsInstructions: '<p></p>',
      customPregnanciesInstructions: '<p></p>',
      CustomFamilyMembers: '<p></p>',
      customConfirmDetailsInstructions: '<p></p>',
      questions: [],
      questionsTitle: ''
    },
    formValidationRules: {
      saveSurnameInitials: true,
      saveDateAsYears: true
    },
    isEnablePregnancy: false,
    isEnableRiskSurvey: false
  },

  methods: {
    fetch: 'fetch',
    save: 'save',
    delete: 'delete',
    submit: 'submit'
  },
  tokenKey: 'fhq_token',
  clientGroupKey: 'client_group_id',
  linkParametersKey: 'link_parameters',

  // used to clean the form data
  removals: [
    'createdAt',
    'updatedAt',
    'status',
    'proBandId',
    'familyId',
    'dateGenerated',
    'currentId',
    'client_id',
    '__v'
  ],

  defaultFamilyAccordions: [
    {
      id: 'panel-mother',
      relationship: allRelations['mother'],
      title: 'Mother',
      gender: GENDER['female']
    },
    {
      id: 'panel-father',
      relationship: allRelations['father'],
      title: 'Father',
      gender: GENDER['male']
    },
    {
      id: 'panel-mothersMother',
      relationship: allRelations['mothersMother'],
      title: 'Maternal Grandmother (Mother’s Mother)',
      gender: GENDER['female']
    },
    {
      id: 'panel-mothersFather',
      relationship: allRelations['mothersFather'],
      title: 'Maternal Grandfather (Mother’s Father)',
      gender: GENDER['male']
    },
    {
      id: 'panel-fathersMother',
      relationship: allRelations['fathersMother'],
      title: 'Paternal Grandmother (Father’s Mother)',
      gender: GENDER['female']
    },
    {
      id: 'panel-fathersFather',
      relationship: allRelations['fathersFather'],
      title: 'Paternal Grandfather (Father’s Father)',
      gender: GENDER['male']
    }
  ],

  booleanCheckFamilyKeys: [
    'isBrotherSister',
    'isSpouse',
    'isChildren',
    'isMumBrotherSister',
    'isDadBrotherSister',
    'isOtherRelative'
  ],

  numberCheckFamilyKeys: [
    'sisterCount',
    'brotherCount',
    'halfSisterCount',
    'halfBrotherCount',
    'daughterCount',
    'sonCount',
    'mumSisterCount',
    'mumBrotherCount',
    'dadSisterCount',
    'dadBrotherCount',
    'otherRelativeCount'
  ]
});

export const getNavItems = (
  isCustomisationEnabled = false,
  customisationTitle,
  isPregnancyEnabled = false,
  isPregnancies = false,
  isEnabledRiskSurvey = false
) => [
  {
    path: CONSTANTS.disclaimerPath,
    label: CONSTANTS.disclaimerLabel,
    icon: 'home'
  },
  {
    path: CONSTANTS.personalDetailsPath,
    label: CONSTANTS.personalDetailsLabel,
    icon: 'person'
  },
  {
    path: CONSTANTS.familyDetailsPath,
    label: CONSTANTS.familyDetailsLabel,
    icon: 'people'
  },
  // Pregnancy comes AFTER family so the respondent's spouses already exist and can be picked
  // as who the pregnancy was conceived with (see PLAN-fhq-pregnancy-conception-capture).
  ...(isPregnancyEnabled && isPregnancies
    ? [
        {
          path: CONSTANTS.pregnancyDetailsPath,
          label: CONSTANTS.pregnancyDetailsLabel,
          icon: 'pregnant'
        }
      ]
    : []),
  // {path: CONSTANTS.confirmDetailsPath, label: CONSTANTS.confirmDetailsLabel, icon: 'numbered-list'},
  ...(isEnabledRiskSurvey
    ? [
        {
          path: CONSTANTS.geneticDetailsPath,
          label: CONSTANTS.geneticDetailsLabel,
          icon: 'wc'
        }
      ]
    : []),
  ...(isCustomisationEnabled
    ? [
        {
          path: CONSTANTS.customisationPath,
          label: customisationTitle,
          icon: 'post-add'
        }
      ]
    : []),
  {
    path: CONSTANTS.reviewPath,
    label: CONSTANTS.reviewLabel,
    icon: 'list-check'
  }
];

export const bloodSpecialityTableHead = [
  'SYMPTOMS (up to the time of diagnosis)',
  '0',
  '1',
  '2',
  '3',
  '4'
];

export const bloodSpecialityTableData = [
  {
    id: 'epistaxis',
    symptoms: 'Epistaxis',
    0: 'No/trivial',
    1: '- > 5/year or - more than 10 minutes',
    2: 'Consultation only*',
    3: 'Packing or cauterization or antifibrinolytic',
    4: 'Blood transfusion or replacement therapy (use of hemostatic blood components and rFVIIa) or desmopressin'
  },
  {
    id: 'cutaneous',
    symptoms: 'Cutaneous',
    0: 'No/trivial',
    1: 'For bruises 5 or more (> 1cm) in exposed areas',
    2: 'Consultation only*',
    3: 'Extensive',
    4: 'Spontaneous hematoma requiring blood transfusion'
  },
  {
    id: 'minorBleeding',
    symptoms: 'Bleeding from minor wounds',
    0: 'No/trivial',
    1: '- > 5/year or - more than 10 minutes',
    2: 'Consultation only*',
    3: 'Surgical hemostasis',
    4: 'Blood transfusion, replacement therapy, or desmopressin'
  },
  {
    id: 'oralCavity',
    symptoms: 'Oral cavity',
    0: 'No/trivial',
    1: 'Present',
    2: 'Consultation only*',
    3: 'Surgical hemostasis or antifibrinolytic',
    4: 'Blood transfusion, replacement therapy or desmopressin'
  },
  {
    id: 'giBleeding',
    symptoms: 'GI bleeding',
    0: 'No/trivial',
    1: 'Present (not associated with ulcer, portal hypertension, hemorrhoids, angiodysplasia)',
    2: 'Consultation only*',
    3: 'Surgical hemostasis, antifibrinolytic',
    4: 'Blood transfusion, replacement therapy or desmopressin'
  },
  {
    id: 'hematuria',
    symptoms: 'Hematuria',
    0: 'No/trivial',
    1: 'Present (macroscopic)',
    2: 'Consultation only*',
    3: 'Surgical hemostasis, iron therapy',
    4: 'Blood transfusion, replacement therapy or desmopressin'
  },
  {
    id: 'toothExtraction',
    symptoms: 'Tooth extraction',
    0: 'No/trivial or none done',
    1: 'Reported in ≤25% of all procedures, no intervention**',
    2: 'Reported in ≥25% of all procedures, no intervention**',
    3: 'Resuturing or packing',
    4: 'Blood transfusion, replacement therapy or desmopressin'
  },
  {
    id: 'surgery',
    symptoms: 'Surgery',
    0: 'No/trivial or none done',
    1: 'Reported in ≤25% of all procedures, no intervention**',
    2: 'Reported in ≥25% of all procedures, no intervention**',
    3: 'Surgical hemostasis or antifibrinolytic',
    4: 'Blood transfusion, replacement therapy or desmopressin'
  },
  {
    id: 'menorrhagia',
    symptoms: 'Menorrhagia',
    0: 'No/trivial',
    1: 'Consultation only* or - Changing pads more frequently than every 2 hours or - Clot and flooding or - PBAC score>100#',
    2: '- Time off work/school > 2/year or - Requiring antifibrinolytics or hormonal or iron therapy',
    3: '- Requiring combined treatment with antifibrinolytics and hormonal therapy or - Present since menarche and > 12 months',
    4: '- Acute menorrhagia requiring hospital admission and emergency treatment or - Requiring blood transfusion, Replacement therapy, Desmopressin, or - Requiring dilatation & curretage or endometrial ablation or hysterectomy)'
  },
  {
    id: 'hemorrhage',
    symptoms: 'Post-partum hemorrhage',
    0: 'No/trivial or no deliveries',
    1: 'Consultation only* or - Use of syntocin or - Lochia > 6 weeks',
    2: '- Iron therapy or - Antifibrinolytics',
    3: '- Requiring blood transfusion, replacement therapy, desmopressin or - Requiring examination under anaesthesia and/or the use of uterin balloon/package to tamponade the uterus',
    4: '- Any procedure requiring critical care or surgical intervention (e.g. hysterectomy, internal iliac artery legation, uterine artery embolization, uterine brace sutures)'
  },
  {
    id: 'hematomas',
    symptoms: 'Muscle hematomas',
    0: 'Never',
    1: 'Post trauma, no therapy',
    2: 'Spontaneous, no therapy',
    3: 'Spontaneous or traumatic, requiring desmopressin or replacement therapy',
    4: 'Spontaneous or traumatic, requiring surgical intervention or blood transfusion'
  },
  {
    id: 'hemarthrosis',
    symptoms: 'Hemarthrosis',
    0: 'Never',
    1: 'Post trauma, no therapy',
    2: 'Spontaneous, no therapy',
    3: 'Spontaneous or traumatic, requiring desmopressin or replacement therapy',
    4: 'Spontaneous or traumatic, requiring surgical intervention or blood transfusion'
  },
  {
    id: 'cnsBleeding',
    symptoms: 'CNS bleeding',
    0: 'Never',
    3: 'Subdural, any intervention',
    4: 'Intracerebral, any intervention'
  },
  {
    id: 'otherBleeding',
    symptoms: 'Other bleedings^',
    0: 'No/trivial',
    1: 'Present',
    2: 'Consultation only*',
    3: 'Surgical hemostasis, antifibrinolytics',
    4: 'Blood transfusion or replacement therapy or desmopressin'
  }
];
export const ETHNICITY_GROUPS = [
  {
    region: 'Oceanian',
    names: [
      'Australian Aboriginal',
      'Australian South Sea Islander',
      'Torres Strait Islander',
      'Norfolk Islander',
      'Maori',
      'New Zealander',
      'New Caledonian',
      'Ni-Vanuatu',
      'Papua New Guinean',
      'Solomon Islander',
      'Melanesian and Papuan, nec',
      'I-Kiribati',
      'Nauruan',
      'Micronesian, nec',
      'Cook Islander',
      'Fijian',
      'Niuean',
      'Samoan',
      'Tongan',
      'Hawaiian',
      'Tahitian',
      'Tokelauan',
      'Tuvaluan',
      'Pitcairn',
      'Polynesian, nec'
    ]
  },
  {
    region: 'North-West European',
    names: [
      'English',
      'Scottish',
      'Welsh',
      'Channel Islander',
      'Manx',
      'British, nec',
      'Irish',
      'Austrian',
      'Dutch',
      'Flemish',
      'French',
      'German',
      'Swiss',
      'Belgian',
      'Frisian',
      'Luxembourg',
      'Western European, nec',
      'Danish',
      'Finnish',
      'Icelandic',
      'Norwegian',
      'Swedish',
      'Northern European, nec'
    ]
  },
  {
    region: 'Southern and Eastern European',
    names: [
      'Basque',
      'Catalan',
      'Italian',
      'Maltese',
      'Portuguese',
      'Spanish',
      'Gibraltarian',
      'Southern European, nec',
      'Albanian',
      'Bosnian',
      'Bulgarian',
      'Croatian',
      'Greek',
      'Macedonian',
      'Moldovan',
      'Montenegrin',
      'Romanian',
      'Roma Gypsy',
      'Serbian',
      'Slovene',
      'Cypriot',
      'Vlach',
      'South Eastern European, nec',
      'Belarusan',
      'Czech',
      'Estonian',
      'Hungarian',
      'Latvian',
      'Lithuanian',
      'Polish',
      'Russian',
      'Slovak',
      'Ukrainian',
      'Sorb/Wend',
      'Eastern European, nec'
    ]
  },
  {
    region: 'North African and Middle Eastern',
    names: [
      'Algerian',
      'Egyptian',
      'Iraqi',
      'Jordanian',
      'Kuwaiti',
      'Lebanese',
      'Libyan',
      'Moroccan',
      'Palestinian',
      'Saudi Arabian',
      'Syrian',
      'Tunisian',
      'Yemeni',
      'Bahraini',
      'Emirati',
      'Omani',
      'Qatari',
      'Arab, nec',
      'Ashkenazi Jewish',
      'Sephardic Jewish',
      'Jewish, nec',
      'Bari',
      'Darfur',
      'Dinka',
      'Nuer',
      'South Sudanese',
      'Sudanese',
      'Peoples of the Sudan, nec',
      'Berber',
      'Coptic',
      'Iranian',
      'Kurdish',
      'Turkish',
      'Assyrian',
      'Chaldean',
      'Mandaean',
      'Nubian',
      'Yezidi',
      'Other North African and Middle Eastern, nec',
      'Mizrahi Jewish'
    ]
  },
  {
    region: 'South-East Asian',
    names: [
      'Anglo-Burmese',
      'Burmese',
      'Hmong',
      'Khmer (Cambodian)',
      'Lao',
      'Thai',
      'Vietnamese',
      'Karen',
      'Mon',
      'Chin',
      'Rohingya',
      'Mainland South-East Asian, nec',
      'Filipino',
      'Indonesian',
      'Javanese',
      'Madurese',
      'Malay',
      'Sundanese',
      'Timorese',
      'Acehnese',
      'Balinese',
      'Bruneian',
      'Kadazan',
      'Singaporean',
      'Temoq',
      'Maritime South-East Asian, nec',
      'Shan',
      'Rakhine',
      'Kachin',
      'Cham',
      'Tagalog',
      'Cebuano',
      'Ilocano',
      'Minangkabau',
      'Batak',
      'Bugis',
      'Iban',
      'Dayak',
      'Peranakan'
    ]
  },
  {
    region: 'North-East Asian',
    names: [
      'Chinese',
      'Taiwanese',
      'Chinese Asian, nec',
      'Japanese',
      'Korean',
      'Mongolian',
      'Tibetan',
      'Other North-East Asian, nec',
      'Cantonese',
      'Hakka',
      'Hokkien',
      'Teochew',
      'Hainanese',
      'Shanghainese',
      'Hui',
      'Manchu',
      'Zhuang',
      'Hong Kong Chinese',
      'Macanese',
      'Okinawan',
      'Ainu'
    ]
  },
  {
    region: 'Southern and Central Asian',
    names: [
      'Anglo-Indian',
      'Bengali',
      'Burgher',
      'Gujarati',
      'Indian',
      'Malayali',
      'Nepalese',
      'Pakistani',
      'Punjabi',
      'Sikh',
      'Sinhalese',
      'Maldivian',
      'Bangladeshi',
      'Bhutanese',
      'Fijian Indian',
      'Kashmiri',
      'Parsi',
      'Sindhi',
      'Sri Lankan',
      'Sri Lankan Tamil',
      'Indian Tamil',
      'Tamil, nfd',
      'Telugu',
      'Southern Asian, nec',
      'Afghan',
      'Armenian',
      'Georgian',
      'Kazakh',
      'Pathan',
      'Uzbek',
      'Azeri',
      'Hazara',
      'Tajik',
      'Tatar',
      'Turkmen',
      'Uighur',
      'Kyrgyz',
      'Central Asian, nec',
      'Marathi',
      'Kannadiga',
      'Odia',
      'Assamese',
      'Konkani',
      'Tulu',
      'Rajasthani',
      'Bihari',
      'Bene Israel',
      'Baloch',
      'Saraiki',
      'Muhajir',
      'Brahui',
      'Sri Lankan Moor',
      'Newar',
      'Sherpa',
      'Tamang'
    ]
  },
  {
    region: 'Peoples of the Americas',
    names: [
      'African American',
      'American',
      'Canadian',
      'French Canadian',
      'Hispanic North American',
      'Native North American Indian',
      'Bermudan',
      'North American, nec',
      'Argentinian',
      'Bolivian',
      'Brazilian',
      'Chilean',
      'Colombian',
      'Ecuadorian',
      'Guyanese',
      'Peruvian',
      'Uruguayan',
      'Venezuelan',
      'Paraguayan',
      'South American, nec',
      'Mexican',
      'Nicaraguan',
      'Salvadoran',
      'Costa Rican',
      'Guatemalan',
      'Mayan',
      'Central American, nec',
      'Cuban',
      'Jamaican',
      'Trinidadian Tobagonian',
      'Barbadian',
      'Puerto Rican',
      'Caribbean Islander, nec'
    ]
  },
  {
    region: 'Sub-Saharan African',
    names: [
      'Akan',
      'Fulani',
      'Ghanaian',
      'Nigerian',
      'Yoruba',
      'Ivorean',
      'Liberian',
      'Sierra Leonean',
      'Acholi',
      'Cameroonian',
      'Congolese',
      'Gio',
      'Igbo',
      'Krahn',
      'Mandinka',
      'Senegalese',
      'Themne',
      'Togolese',
      'Central and West African, nec',
      'Afrikaner',
      'Angolan',
      'Eritrean',
      'Ethiopian',
      'Kenyan',
      'Malawian',
      'Mauritian',
      'Mozambican',
      'Namibian',
      'Oromo',
      'Seychellois',
      'Somali',
      'South African',
      'Tanzanian',
      'Ugandan',
      'Zambian',
      'Zimbabwean',
      'Amhara',
      'Batswana',
      'Hutu',
      'Masai',
      'Tigrayan',
      'Tigre',
      'Zulu',
      'Burundian',
      'Kunama',
      'Madi',
      'Ogaden',
      'Rwandan',
      'Shona',
      'Swahili',
      'Swazilander',
      'Southern and East African, nec'
    ]
  }
];

export const ETHNICITY_REGIONS = ETHNICITY_GROUPS.map((g) => g.region);
export const allEthnicities = ETHNICITY_GROUPS.flatMap((g) => g.names);

const ETHNICITY_REGION_BY_NAME = new Map(
  ETHNICITY_GROUPS.flatMap((g) => g.names.map((name) => [name, g.region]))
);

export const ethnicityRegion = (name) =>
  ETHNICITY_REGION_BY_NAME.get(name) || '';

export const ethnicityMap = Object.fromEntries(
  allEthnicities.map((name) => [name, name])
);

export const RELIGION_DECLINED = {
  system: 'http://terminology.hl7.org/CodeSystem/data-absent-reason',
  code: 'asked-declined',
  display: 'Prefer not to say'
};

export const RELIGION_CLASSIFICATIONS = [
  {
    key: 'abs-ascrg',
    label: 'ABS ASCRG (Australia)',
    publisher: 'Australian Bureau of Statistics',
    sourceTitle:
      '1266.0 Australian Standard Classification of Religious Groups, 2024',
    sourceUrl:
      'https://www.abs.gov.au/statistics/classifications/australian-standard-classification-religious-groups/2024',
    version: '2024',
    levels: [
      {
        key: 'broad',
        label: 'Broad groups',
        system:
          'https://www.abs.gov.au/statistics/classifications/australian-standard-classification-religious-groups/2024',
        concepts: [
          { code: '15', display: 'Buddhism' },
          { code: '25', display: 'Christianity' },
          { code: '35', display: 'Hinduism' },
          { code: '45', display: 'Islam' },
          { code: '55', display: 'Judaism' },
          { code: '65', display: 'Sikhism' },
          { code: '85', display: 'Other Religions' },
          {
            code: '95',
            display:
              'Secular Beliefs and Other Spiritual Beliefs and No Religious Affiliation'
          }
        ]
      },
      {
        key: 'narrow',
        label: 'Narrow groups',
        system:
          'https://www.abs.gov.au/statistics/classifications/australian-standard-classification-religious-groups/2024',
        concepts: [
          {
            code: '1511',
            display: 'Buddhism',
            group: 'Buddhism',
            parent: '15'
          },
          {
            code: '2511',
            display: 'Anglican',
            group: 'Christianity',
            parent: '25'
          },
          {
            code: '2512',
            display: 'Assyrian Apostolic',
            group: 'Christianity',
            parent: '25'
          },
          {
            code: '2513',
            display: 'Baptist',
            group: 'Christianity',
            parent: '25'
          },
          {
            code: '2514',
            display: 'Brethren',
            group: 'Christianity',
            parent: '25'
          },
          {
            code: '2515',
            display: 'Catholic',
            group: 'Christianity',
            parent: '25'
          },
          {
            code: '2516',
            display: 'Churches of Christ',
            group: 'Christianity',
            parent: '25'
          },
          {
            code: '2517',
            display: 'Eastern Orthodox',
            group: 'Christianity',
            parent: '25'
          },
          {
            code: '2518',
            display: "Jehovah's Witnesses",
            group: 'Christianity',
            parent: '25'
          },
          {
            code: '2521',
            display: 'Latter-day Saints',
            group: 'Christianity',
            parent: '25'
          },
          {
            code: '2522',
            display: 'Lutheran',
            group: 'Christianity',
            parent: '25'
          },
          {
            code: '2523',
            display: 'Oriental Orthodox',
            group: 'Christianity',
            parent: '25'
          },
          {
            code: '2524',
            display: 'Pentecostal',
            group: 'Christianity',
            parent: '25'
          },
          {
            code: '2525',
            display: 'Presbyterian and Reformed',
            group: 'Christianity',
            parent: '25'
          },
          {
            code: '2526',
            display: 'Salvation Army',
            group: 'Christianity',
            parent: '25'
          },
          {
            code: '2527',
            display: 'Seventh-day Adventist',
            group: 'Christianity',
            parent: '25'
          },
          {
            code: '2528',
            display: 'Uniting Church',
            group: 'Christianity',
            parent: '25'
          },
          {
            code: '2531',
            display: 'Other Protestant',
            group: 'Christianity',
            parent: '25'
          },
          {
            code: '2532',
            display: 'Other Christian',
            group: 'Christianity',
            parent: '25'
          },
          {
            code: '3511',
            display: 'Hinduism',
            group: 'Hinduism',
            parent: '35'
          },
          { code: '4511', display: 'Shia', group: 'Islam', parent: '45' },
          { code: '4512', display: 'Sunni', group: 'Islam', parent: '45' },
          {
            code: '4513',
            display: 'Other Islam',
            group: 'Islam',
            parent: '45'
          },
          { code: '5511', display: 'Judaism', group: 'Judaism', parent: '55' },
          { code: '6511', display: 'Sikhism', group: 'Sikhism', parent: '65' },
          {
            code: '8511',
            display: 'Australian Aboriginal Traditional Religions',
            group: 'Other Religions',
            parent: '85'
          },
          {
            code: '8512',
            display: "Baha'i",
            group: 'Other Religions',
            parent: '85'
          },
          {
            code: '8513',
            display: 'Chinese Religions',
            group: 'Other Religions',
            parent: '85'
          },
          {
            code: '8514',
            display: 'Druse',
            group: 'Other Religions',
            parent: '85'
          },
          {
            code: '8515',
            display: 'Japanese Religions',
            group: 'Other Religions',
            parent: '85'
          },
          {
            code: '8516',
            display: 'Nature Religions',
            group: 'Other Religions',
            parent: '85'
          },
          {
            code: '8517',
            display: 'Spiritualism',
            group: 'Other Religions',
            parent: '85'
          },
          {
            code: '8518',
            display: 'Miscellaneous Religions',
            group: 'Other Religions',
            parent: '85'
          },
          {
            code: '9511',
            display: 'No Religion, so described',
            group:
              'Secular Beliefs and Other Spiritual Beliefs and No Religious Affiliation',
            parent: '95'
          },
          {
            code: '9512',
            display: 'Secular Beliefs',
            group:
              'Secular Beliefs and Other Spiritual Beliefs and No Religious Affiliation',
            parent: '95'
          },
          {
            code: '9513',
            display: 'Other Spiritual Beliefs',
            group:
              'Secular Beliefs and Other Spiritual Beliefs and No Religious Affiliation',
            parent: '95'
          }
        ]
      },
      {
        key: 'detailed',
        label: 'Religious groups',
        system:
          'https://www.abs.gov.au/statistics/classifications/australian-standard-classification-religious-groups/2024',
        concepts: [
          {
            code: '151111',
            display: 'Mahayana Buddhism',
            group: 'Buddhism',
            parent: '1511'
          },
          {
            code: '151112',
            display: 'Theravada Buddhism',
            group: 'Buddhism',
            parent: '1511'
          },
          {
            code: '151113',
            display: 'Vajrayana Buddhism',
            group: 'Buddhism',
            parent: '1511'
          },
          {
            code: '251111',
            display: 'Anglican Catholic Church',
            group: 'Christianity',
            parent: '2511'
          },
          {
            code: '251112',
            display: 'Anglican Church of Australia',
            group: 'Christianity',
            parent: '2511'
          },
          {
            code: '251199',
            display: 'Anglican, nec',
            group: 'Christianity',
            parent: '2511'
          },
          {
            code: '251211',
            display: 'Ancient Church of the East',
            group: 'Christianity',
            parent: '2512'
          },
          {
            code: '251212',
            display: 'Assyrian Church of the East',
            group: 'Christianity',
            parent: '2512'
          },
          {
            code: '251299',
            display: 'Assyrian Apostolic, nec',
            group: 'Christianity',
            parent: '2512'
          },
          {
            code: '251311',
            display: 'Baptist',
            group: 'Christianity',
            parent: '2513'
          },
          {
            code: '251411',
            display: 'Brethren',
            group: 'Christianity',
            parent: '2514'
          },
          {
            code: '251511',
            display: 'Chaldean Catholic',
            group: 'Christianity',
            parent: '2515'
          },
          {
            code: '251512',
            display: 'Maronite Catholic',
            group: 'Christianity',
            parent: '2515'
          },
          {
            code: '251513',
            display: 'Melkite Catholic',
            group: 'Christianity',
            parent: '2515'
          },
          {
            code: '251514',
            display: 'Syriac Catholic',
            group: 'Christianity',
            parent: '2515'
          },
          {
            code: '251515',
            display: 'Syro Malabar Catholic',
            group: 'Christianity',
            parent: '2515'
          },
          {
            code: '251516',
            display: 'Ukrainian Catholic',
            group: 'Christianity',
            parent: '2515'
          },
          {
            code: '251517',
            display: 'Western Catholic',
            group: 'Christianity',
            parent: '2515'
          },
          {
            code: '251599',
            display: 'Catholic, nec',
            group: 'Christianity',
            parent: '2515'
          },
          {
            code: '251611',
            display: 'Church of Christ (Non-denominational)',
            group: 'Christianity',
            parent: '2516'
          },
          {
            code: '251612',
            display: 'Churches of Christ (Conference)',
            group: 'Christianity',
            parent: '2516'
          },
          {
            code: '251613',
            display: 'International Church of Christ',
            group: 'Christianity',
            parent: '2516'
          },
          {
            code: '251711',
            display: 'Antiochian Orthodox',
            group: 'Christianity',
            parent: '2517'
          },
          {
            code: '251712',
            display: 'Greek Orthodox',
            group: 'Christianity',
            parent: '2517'
          },
          {
            code: '251713',
            display: 'Macedonian Orthodox',
            group: 'Christianity',
            parent: '2517'
          },
          {
            code: '251714',
            display: 'Romanian Orthodox',
            group: 'Christianity',
            parent: '2517'
          },
          {
            code: '251715',
            display: 'Russian Orthodox',
            group: 'Christianity',
            parent: '2517'
          },
          {
            code: '251716',
            display: 'Serbian Orthodox',
            group: 'Christianity',
            parent: '2517'
          },
          {
            code: '251717',
            display: 'Ukrainian Orthodox',
            group: 'Christianity',
            parent: '2517'
          },
          {
            code: '251799',
            display: 'Eastern Orthodox, nec',
            group: 'Christianity',
            parent: '2517'
          },
          {
            code: '251811',
            display: "Jehovah's Witnesses",
            group: 'Christianity',
            parent: '2518'
          },
          {
            code: '252111',
            display: 'Community of Christ',
            group: 'Christianity',
            parent: '2521'
          },
          {
            code: '252112',
            display: 'The Church of Jesus Christ of Latter-day Saints',
            group: 'Christianity',
            parent: '2521'
          },
          {
            code: '252211',
            display: 'Lutheran',
            group: 'Christianity',
            parent: '2522'
          },
          {
            code: '252311',
            display: 'Armenian Apostolic',
            group: 'Christianity',
            parent: '2523'
          },
          {
            code: '252312',
            display: 'Coptic Orthodox Church',
            group: 'Christianity',
            parent: '2523'
          },
          {
            code: '252313',
            display: 'Ethiopian Orthodox Church',
            group: 'Christianity',
            parent: '2523'
          },
          {
            code: '252314',
            display: 'Syrian Orthodox Church',
            group: 'Christianity',
            parent: '2523'
          },
          {
            code: '252399',
            display: 'Oriental Orthodox, nec',
            group: 'Christianity',
            parent: '2523'
          },
          {
            code: '252411',
            display: 'Acts 2 Alliance',
            group: 'Christianity',
            parent: '2524'
          },
          {
            code: '252412',
            display: 'Apostolic Church (Australia)',
            group: 'Christianity',
            parent: '2524'
          },
          {
            code: '252413',
            display: 'Australian Christian Churches (Assemblies of God)',
            group: 'Christianity',
            parent: '2524'
          },
          {
            code: '252414',
            display: 'Bethesda Ministries International (Bethesda Churches)',
            group: 'Christianity',
            parent: '2524'
          },
          {
            code: '252415',
            display: 'C3 Church Global (Christian City Church)',
            group: 'Christianity',
            parent: '2524'
          },
          {
            code: '252416',
            display: 'Christian Church in Australia',
            group: 'Christianity',
            parent: '2524'
          },
          {
            code: '252417',
            display: 'CRC International (Christian Revival Crusade)',
            group: 'Christianity',
            parent: '2524'
          },
          {
            code: '252418',
            display: 'Foursquare Gospel Church',
            group: 'Christianity',
            parent: '2524'
          },
          {
            code: '252421',
            display: 'Full Gospel Church of Australia (Full Gospel Church)',
            group: 'Christianity',
            parent: '2524'
          },
          {
            code: '252422',
            display:
              'International Network of Churches (Christian Outreach Centres)',
            group: 'Christianity',
            parent: '2524'
          },
          {
            code: '252423',
            display: 'Pentecostal City Life Church',
            group: 'Christianity',
            parent: '2524'
          },
          {
            code: '252424',
            display: 'Revival Centres',
            group: 'Christianity',
            parent: '2524'
          },
          {
            code: '252425',
            display: 'Revival Fellowship',
            group: 'Christianity',
            parent: '2524'
          },
          {
            code: '252426',
            display: 'Rhema Family Church',
            group: 'Christianity',
            parent: '2524'
          },
          {
            code: '252427',
            display: 'United Pentecostal',
            group: 'Christianity',
            parent: '2524'
          },
          {
            code: '252428',
            display: 'Victory Life Centre',
            group: 'Christianity',
            parent: '2524'
          },
          {
            code: '252431',
            display: 'Victory Worship Centre',
            group: 'Christianity',
            parent: '2524'
          },
          {
            code: '252432',
            display: 'Worship Centre Network',
            group: 'Christianity',
            parent: '2524'
          },
          {
            code: '252499',
            display: 'Pentecostal, nec',
            group: 'Christianity',
            parent: '2524'
          },
          {
            code: '252511',
            display: 'Free Reformed',
            group: 'Christianity',
            parent: '2525'
          },
          {
            code: '252512',
            display: 'Presbyterian',
            group: 'Christianity',
            parent: '2525'
          },
          {
            code: '252513',
            display: 'Reformed',
            group: 'Christianity',
            parent: '2525'
          },
          {
            code: '252611',
            display: 'Salvation Army',
            group: 'Christianity',
            parent: '2526'
          },
          {
            code: '252711',
            display: 'Seventh-day Adventist',
            group: 'Christianity',
            parent: '2527'
          },
          {
            code: '252811',
            display: 'Uniting Church',
            group: 'Christianity',
            parent: '2528'
          },
          {
            code: '253111',
            display: 'Aboriginal Evangelical Missions',
            group: 'Christianity',
            parent: '2531'
          },
          {
            code: '253112',
            display: 'Born Again Christian',
            group: 'Christianity',
            parent: '2531'
          },
          {
            code: '253113',
            display: 'Christian and Missionary Alliance',
            group: 'Christianity',
            parent: '2531'
          },
          {
            code: '253114',
            display: 'Christian Community Churches of Australia',
            group: 'Christianity',
            parent: '2531'
          },
          {
            code: '253115',
            display: 'Church of the Nazarene',
            group: 'Christianity',
            parent: '2531'
          },
          {
            code: '253116',
            display: 'Congregational',
            group: 'Christianity',
            parent: '2531'
          },
          {
            code: '253117',
            display: 'Ethnic Evangelical Churches',
            group: 'Christianity',
            parent: '2531'
          },
          {
            code: '253118',
            display: 'Independent Evangelical Churches',
            group: 'Christianity',
            parent: '2531'
          },
          {
            code: '253121',
            display: 'Methodist, so described',
            group: 'Christianity',
            parent: '2531'
          },
          {
            code: '253122',
            display: 'United Methodist Church',
            group: 'Christianity',
            parent: '2531'
          },
          {
            code: '253123',
            display: 'Wesleyan Methodist Church',
            group: 'Christianity',
            parent: '2531'
          },
          {
            code: '253199',
            display: 'Other Protestant, nec',
            group: 'Christianity',
            parent: '2531'
          },
          {
            code: '253211',
            display: 'Apostolic Church of Queensland',
            group: 'Christianity',
            parent: '2532'
          },
          {
            code: '253212',
            display: 'Christadelphians',
            group: 'Christianity',
            parent: '2532'
          },
          {
            code: '253213',
            display: 'Christian Science',
            group: 'Christianity',
            parent: '2532'
          },
          {
            code: '253214',
            display: 'Gnostic Christians',
            group: 'Christianity',
            parent: '2532'
          },
          {
            code: '253215',
            display: 'Grace Communion International (Worldwide Church of God)',
            group: 'Christianity',
            parent: '2532'
          },
          {
            code: '253216',
            display: 'Liberal Catholic Church',
            group: 'Christianity',
            parent: '2532'
          },
          {
            code: '253217',
            display: 'New Apostolic Church',
            group: 'Christianity',
            parent: '2532'
          },
          {
            code: '253218',
            display: 'New Churches (Swedenborgian)',
            group: 'Christianity',
            parent: '2532'
          },
          {
            code: '253221',
            display: 'Ratana (Māori)',
            group: 'Christianity',
            parent: '2532'
          },
          {
            code: '253222',
            display: 'Religious Science',
            group: 'Christianity',
            parent: '2532'
          },
          {
            code: '253223',
            display: 'Religious Society of Friends (Quakers)',
            group: 'Christianity',
            parent: '2532'
          },
          {
            code: '253224',
            display: 'Temple Society',
            group: 'Christianity',
            parent: '2532'
          },
          {
            code: '253299',
            display: 'Other Christian, nec',
            group: 'Christianity',
            parent: '2532'
          },
          {
            code: '351111',
            display: 'Hinduism',
            group: 'Hinduism',
            parent: '3511'
          },
          { code: '451111', display: 'Shia', group: 'Islam', parent: '4511' },
          { code: '451211', display: 'Sunni', group: 'Islam', parent: '4512' },
          {
            code: '451311',
            display: 'Ahmadiyya',
            group: 'Islam',
            parent: '4513'
          },
          { code: '451312', display: 'Alawi', group: 'Islam', parent: '4513' },
          { code: '451313', display: 'Alevi', group: 'Islam', parent: '4513' },
          {
            code: '451399',
            display: 'Islam, nec',
            group: 'Islam',
            parent: '4513'
          },
          {
            code: '551111',
            display: 'Judaism',
            group: 'Judaism',
            parent: '5511'
          },
          {
            code: '651111',
            display: 'Sikhism',
            group: 'Sikhism',
            parent: '6511'
          },
          {
            code: '851111',
            display: 'Australian Aboriginal Traditional Religions',
            group: 'Other Religions',
            parent: '8511'
          },
          {
            code: '851211',
            display: "Baha'i",
            group: 'Other Religions',
            parent: '8512'
          },
          {
            code: '851311',
            display: 'Ancestor Veneration',
            group: 'Other Religions',
            parent: '8513'
          },
          {
            code: '851312',
            display: 'Confucianism',
            group: 'Other Religions',
            parent: '8513'
          },
          {
            code: '851313',
            display: 'Taoism',
            group: 'Other Religions',
            parent: '8513'
          },
          {
            code: '851399',
            display: 'Chinese Religions, nec',
            group: 'Other Religions',
            parent: '8513'
          },
          {
            code: '851411',
            display: 'Druse',
            group: 'Other Religions',
            parent: '8514'
          },
          {
            code: '851511',
            display: 'Shinto',
            group: 'Other Religions',
            parent: '8515'
          },
          {
            code: '851512',
            display: 'Sukyo Mahikari',
            group: 'Other Religions',
            parent: '8515'
          },
          {
            code: '851513',
            display: 'Tenrikyo',
            group: 'Other Religions',
            parent: '8515'
          },
          {
            code: '851599',
            display: 'Japanese Religions, nec',
            group: 'Other Religions',
            parent: '8515'
          },
          {
            code: '851611',
            display: 'Animism',
            group: 'Other Religions',
            parent: '8516'
          },
          {
            code: '851612',
            display: 'Druidism',
            group: 'Other Religions',
            parent: '8516'
          },
          {
            code: '851613',
            display: 'Paganism',
            group: 'Other Religions',
            parent: '8516'
          },
          {
            code: '851614',
            display: 'Wiccan (Witchcraft)',
            group: 'Other Religions',
            parent: '8516'
          },
          {
            code: '851699',
            display: 'Nature Religions, nec',
            group: 'Other Religions',
            parent: '8516'
          },
          {
            code: '851711',
            display: 'Spiritualism',
            group: 'Other Religions',
            parent: '8517'
          },
          {
            code: '851811',
            display: 'Caodaism',
            group: 'Other Religions',
            parent: '8518'
          },
          {
            code: '851812',
            display: 'Church of Scientology',
            group: 'Other Religions',
            parent: '8518'
          },
          {
            code: '851813',
            display: 'Eckankar',
            group: 'Other Religions',
            parent: '8518'
          },
          {
            code: '851814',
            display: 'Jainism',
            group: 'Other Religions',
            parent: '8518'
          },
          {
            code: '851815',
            display: 'Kirat Mundham',
            group: 'Other Religions',
            parent: '8518'
          },
          {
            code: '851816',
            display: 'Mandaean',
            group: 'Other Religions',
            parent: '8518'
          },
          {
            code: '851817',
            display: 'Rastafari',
            group: 'Other Religions',
            parent: '8518'
          },
          {
            code: '851818',
            display: 'Satanism',
            group: 'Other Religions',
            parent: '8518'
          },
          {
            code: '851821',
            display: 'Theosophy',
            group: 'Other Religions',
            parent: '8518'
          },
          {
            code: '851822',
            display: 'Yazidi',
            group: 'Other Religions',
            parent: '8518'
          },
          {
            code: '851823',
            display: 'Zoroastrianism',
            group: 'Other Religions',
            parent: '8518'
          },
          {
            code: '851899',
            display: 'Religious Groups, nec',
            group: 'Other Religions',
            parent: '8518'
          },
          {
            code: '951111',
            display: 'No Religion, so described',
            group:
              'Secular Beliefs and Other Spiritual Beliefs and No Religious Affiliation',
            parent: '9511'
          },
          {
            code: '951211',
            display: 'Agnosticism',
            group:
              'Secular Beliefs and Other Spiritual Beliefs and No Religious Affiliation',
            parent: '9512'
          },
          {
            code: '951212',
            display: 'Atheism',
            group:
              'Secular Beliefs and Other Spiritual Beliefs and No Religious Affiliation',
            parent: '9512'
          },
          {
            code: '951213',
            display: 'Humanism',
            group:
              'Secular Beliefs and Other Spiritual Beliefs and No Religious Affiliation',
            parent: '9512'
          },
          {
            code: '951214',
            display: 'Rationalism',
            group:
              'Secular Beliefs and Other Spiritual Beliefs and No Religious Affiliation',
            parent: '9512'
          },
          {
            code: '951299',
            display: 'Secular Beliefs, nec',
            group:
              'Secular Beliefs and Other Spiritual Beliefs and No Religious Affiliation',
            parent: '9512'
          },
          {
            code: '951311',
            display: 'Multi Faith',
            group:
              'Secular Beliefs and Other Spiritual Beliefs and No Religious Affiliation',
            parent: '9513'
          },
          {
            code: '951312',
            display: 'New Age',
            group:
              'Secular Beliefs and Other Spiritual Beliefs and No Religious Affiliation',
            parent: '9513'
          },
          {
            code: '951313',
            display: 'Own Spiritual Beliefs',
            group:
              'Secular Beliefs and Other Spiritual Beliefs and No Religious Affiliation',
            parent: '9513'
          },
          {
            code: '951314',
            display: 'Theism',
            group:
              'Secular Beliefs and Other Spiritual Beliefs and No Religious Affiliation',
            parent: '9513'
          },
          {
            code: '951315',
            display: 'Unitarian Universalism',
            group:
              'Secular Beliefs and Other Spiritual Beliefs and No Religious Affiliation',
            parent: '9513'
          },
          {
            code: '951399',
            display: 'Other Spiritual Beliefs, nec',
            group:
              'Secular Beliefs and Other Spiritual Beliefs and No Religious Affiliation',
            parent: '9513'
          },
          {
            code: '000000',
            display: 'Inadequately described',
            group: 'Supplementary codes',
            defaultShow: false
          },
          {
            code: '000001',
            display: 'Not Stated',
            group: 'Supplementary codes',
            defaultShow: false
          },
          {
            code: '151100',
            display: 'Buddhism nfd',
            group: 'Supplementary codes',
            defaultShow: false
          },
          {
            code: '250000',
            display: 'Christianity, nfd',
            group: 'Supplementary codes',
            defaultShow: false
          },
          {
            code: '251100',
            display: 'Anglican, nfd',
            group: 'Supplementary codes',
            defaultShow: false
          },
          {
            code: '251200',
            display: 'Assyrian Apostolic, nfd',
            group: 'Supplementary codes',
            defaultShow: false
          },
          {
            code: '251500',
            display: 'Catholic, nfd',
            group: 'Supplementary codes',
            defaultShow: false
          },
          {
            code: '251600',
            display: 'Churches of Christ, nfd',
            group: 'Supplementary codes',
            defaultShow: false
          },
          {
            code: '251700',
            display: 'Eastern Orthodox, nfd',
            group: 'Supplementary codes',
            defaultShow: false
          },
          {
            code: '252100',
            display: 'Latter-day Saints, nfd',
            group: 'Supplementary codes',
            defaultShow: false
          },
          {
            code: '252300',
            display: 'Oriental Orthodox, nfd',
            group: 'Supplementary codes',
            defaultShow: false
          },
          {
            code: '252400',
            display: 'Pentecostal, nfd',
            group: 'Supplementary codes',
            defaultShow: false
          },
          {
            code: '252500',
            display: 'Presbyterian and Reformed, nfd',
            group: 'Supplementary codes',
            defaultShow: false
          },
          {
            code: '253100',
            display: 'Other Protestant, nfd',
            group: 'Supplementary codes',
            defaultShow: false
          },
          {
            code: '253200',
            display: 'Other Christian, nfd',
            group: 'Supplementary codes',
            defaultShow: false
          },
          {
            code: '450000',
            display: 'Islam, nfd',
            group: 'Supplementary codes',
            defaultShow: false
          },
          {
            code: '451300',
            display: 'Other Islam, nfd',
            group: 'Supplementary codes',
            defaultShow: false
          },
          {
            code: '850000',
            display: 'Other Religions, nfd',
            group: 'Supplementary codes',
            defaultShow: false
          },
          {
            code: '851300',
            display: 'Chinese Religions, nfd',
            group: 'Supplementary codes',
            defaultShow: false
          },
          {
            code: '851500',
            display: 'Japanese Religions, nfd',
            group: 'Supplementary codes',
            defaultShow: false
          },
          {
            code: '851600',
            display: 'Nature Religions, nfd',
            group: 'Supplementary codes',
            defaultShow: false
          },
          {
            code: '851800',
            display: 'Miscellaneous Religions, nfd',
            group: 'Supplementary codes',
            defaultShow: false
          },
          {
            code: '950000',
            display:
              'Secular Beliefs and Other Spiritual Beliefs and No Religious Affiliation, nfd',
            group: 'Supplementary codes',
            defaultShow: false
          },
          {
            code: '951200',
            display: 'Secular Beliefs, nfd',
            group: 'Supplementary codes',
            defaultShow: false
          },
          {
            code: '951300',
            display: 'Other Spiritual Beliefs, nfd',
            group: 'Supplementary codes',
            defaultShow: false
          }
        ]
      }
    ]
  },
  {
    key: 'ons',
    label: 'ONS (England & Wales)',
    publisher: 'Office for National Statistics',
    sourceTitle: 'Census 2021 Religion variable classifications',
    sourceUrl:
      'https://www.ons.gov.uk/census/census2021dictionary/variablesbytopic/ethnic-group-national-identity-language-and-religion-variables-census-2021/religion',
    version: '2021',
    levels: [
      {
        key: 'high-level',
        label: 'Religion (10 categories)',
        system:
          'https://www.ons.gov.uk/census/census2021dictionary/variablesbytopic/ethnic-group-national-identity-language-and-religion-variables-census-2021/religion#religion_tb',
        concepts: [
          { code: '1', display: 'No religion' },
          { code: '2', display: 'Christian' },
          { code: '3', display: 'Buddhist' },
          { code: '4', display: 'Hindu' },
          { code: '5', display: 'Jewish' },
          { code: '6', display: 'Muslim' },
          { code: '7', display: 'Sikh' },
          { code: '8', display: 'Other religion' },
          { code: '9', display: 'Not answered' },
          { code: '-8', display: 'Does not apply' }
        ]
      },
      {
        key: 'detailed-58a',
        label: 'Religion detailed 58a (58 categories)',
        system:
          'https://www.ons.gov.uk/census/census2021dictionary/variablesbytopic/ethnic-group-national-identity-language-and-religion-variables-census-2021/religion#religion_58a',
        concepts: [
          { code: '1', display: 'Christian' },
          { code: '2', display: 'Buddhist' },
          { code: '3', display: 'Hindu' },
          { code: '4', display: 'Jewish' },
          { code: '5', display: 'Muslim' },
          { code: '6', display: 'Sikh' },
          {
            code: '7',
            display: 'Other religion: Alevi',
            group: 'Other religion'
          },
          { code: '8', display: 'No religion: Agnostic', group: 'No religion' },
          { code: '9', display: 'No religion: Atheist', group: 'No religion' },
          {
            code: '10',
            display: 'No religion: Free Thinker',
            group: 'No religion'
          },
          {
            code: '11',
            display: 'No religion: Humanist',
            group: 'No religion'
          },
          {
            code: '12',
            display: 'No religion: No religion',
            group: 'No religion'
          },
          { code: '13', display: 'No religion: Realist', group: 'No religion' },
          {
            code: '14',
            display: 'Other religion: Animism',
            group: 'Other religion'
          },
          {
            code: '15',
            display: "Other religion: Baha'i",
            group: 'Other religion'
          },
          {
            code: '16',
            display: 'Other religion: Believe in God',
            group: 'Other religion'
          },
          {
            code: '17',
            display: 'Other religion: Brahma Kumari',
            group: 'Other religion'
          },
          {
            code: '18',
            display: 'Other religion: Chinese Religion',
            group: 'Other religion'
          },
          {
            code: '19',
            display: 'Other religion: Church of All Religion',
            group: 'Other religion'
          },
          {
            code: '20',
            display: 'Other religion: Confucianist',
            group: 'Other religion'
          },
          {
            code: '21',
            display: 'Other religion: Deist',
            group: 'Other religion'
          },
          {
            code: '22',
            display: 'Other religion: Druid',
            group: 'Other religion'
          },
          {
            code: '23',
            display: 'Other religion: Druze',
            group: 'Other religion'
          },
          {
            code: '24',
            display: 'Other religion: Eckankar',
            group: 'Other religion'
          },
          {
            code: '25',
            display: 'Other religion: Heathen',
            group: 'Other religion'
          },
          {
            code: '26',
            display: 'Other religion: Jain',
            group: 'Other religion'
          },
          {
            code: '27',
            display: 'Other religion: Mixed Religion',
            group: 'Other religion'
          },
          {
            code: '28',
            display: 'Other religion: Mysticism',
            group: 'Other religion'
          },
          {
            code: '29',
            display: 'Other religion: Native American Church',
            group: 'Other religion'
          },
          {
            code: '30',
            display: 'Other religion: New Age',
            group: 'Other religion'
          },
          {
            code: '31',
            display: 'Other religion: Occult',
            group: 'Other religion'
          },
          {
            code: '32',
            display: 'Other religion: Other religions',
            group: 'Other religion'
          },
          {
            code: '33',
            display: 'Other religion: Own Belief System',
            group: 'Other religion'
          },
          {
            code: '34',
            display: 'Other religion: Pagan',
            group: 'Other religion'
          },
          {
            code: '35',
            display: 'Other religion: Pantheism',
            group: 'Other religion'
          },
          {
            code: '36',
            display: 'Other religion: Rastafarian',
            group: 'Other religion'
          },
          {
            code: '37',
            display: 'Other religion: Ravidassia',
            group: 'Other religion'
          },
          {
            code: '38',
            display: 'Other religion: Reconstructionist',
            group: 'Other religion'
          },
          {
            code: '39',
            display: 'Other religion: Satanism',
            group: 'Other religion'
          },
          {
            code: '40',
            display: 'Other religion: Scientology',
            group: 'Other religion'
          },
          {
            code: '41',
            display: 'Other religion: Shamanism',
            group: 'Other religion'
          },
          {
            code: '42',
            display: 'Other religion: Shintoism',
            group: 'Other religion'
          },
          {
            code: '43',
            display: 'Other religion: Spiritual',
            group: 'Other religion'
          },
          {
            code: '44',
            display: 'Other religion: Spiritualist',
            group: 'Other religion'
          },
          {
            code: '45',
            display: 'Other religion: Taoist',
            group: 'Other religion'
          },
          {
            code: '46',
            display: 'Other religion: Theism',
            group: 'Other religion'
          },
          {
            code: '47',
            display: 'Other religion: Thelemite',
            group: 'Other religion'
          },
          {
            code: '48',
            display: 'Other religion: Traditional African Religion',
            group: 'Other religion'
          },
          {
            code: '49',
            display: 'Other religion: Unification Church',
            group: 'Other religion'
          },
          {
            code: '50',
            display: 'Other religion: Universalist',
            group: 'Other religion'
          },
          {
            code: '51',
            display: 'Other religion: Valmiki',
            group: 'Other religion'
          },
          {
            code: '52',
            display: 'Other religion: Vodun',
            group: 'Other religion'
          },
          {
            code: '53',
            display: 'Other religion: Wicca',
            group: 'Other religion'
          },
          {
            code: '54',
            display: 'Other religion: Witchcraft',
            group: 'Other religion'
          },
          {
            code: '55',
            display: 'Other religion: Yazidi',
            group: 'Other religion'
          },
          {
            code: '56',
            display: 'Other religion: Zoroastrian',
            group: 'Other religion'
          },
          { code: '57', display: 'Not answered' },
          { code: '-8', display: 'Does not apply' }
        ]
      },
      {
        key: 'detailed',
        label: 'Religion detailed (191 categories)',
        system:
          'https://www.ons.gov.uk/census/census2021dictionary/variablesbytopic/ethnic-group-national-identity-language-and-religion-variables-census-2021/religion#religion',
        concepts: [
          { code: '001', display: 'Anglican' },
          { code: '002', display: 'Church of England' },
          { code: '003', display: 'Roman Catholic' },
          { code: '004', display: 'Catholic Apostolic Church' },
          { code: '005', display: 'Ukrainian Catholic' },
          { code: '006', display: 'Greek Catholic' },
          { code: '008', display: 'Coptic Orthodox Church' },
          { code: '009', display: 'Eastern Orthodox Church' },
          { code: '010', display: 'Greek Orthodox' },
          { code: '011', display: 'Orthodox Catholic Church' },
          { code: '012', display: 'Orthodox Church' },
          { code: '014', display: 'Russian Orthodox Church' },
          { code: '015', display: 'Ukrainian Orthodox Church' },
          { code: '016', display: 'Serbian Orthodox Church' },
          { code: '017', display: 'Bulgarian Orthodox Church' },
          { code: '018', display: 'Apostolic Church' },
          { code: '019', display: 'Church of God' },
          { code: '020', display: 'Romanian Orthodox Church' },
          { code: '022', display: 'Pentecostal' },
          { code: '023', display: 'Methodist Church In Ireland' },
          { code: '024', display: 'African Methodist' },
          { code: '026', display: 'Baptist' },
          {
            code: '027',
            display: 'Combined Methodist and Presbyterian Church'
          },
          { code: '028', display: 'Free Church of Scotland' },
          { code: '029', display: 'Free Evangelical Church' },
          { code: '030', display: 'Free Methodist' },
          { code: '031', display: 'Free Presbyterian' },
          { code: '032', display: 'Free Presbyterian Church of Scotland' },
          { code: '033', display: 'Free Presbyterian Church of Ulster' },
          { code: '034', display: 'Independent Methodist' },
          { code: '035', display: 'Methodist' },
          { code: '036', display: 'Salvation Army' },
          { code: '037', display: 'United Free Church of Scotland' },
          { code: '038', display: 'United Reformed Church' },
          { code: '039', display: 'The Methodist Church in Wales' },
          { code: '040', display: 'Christadelphian' },
          {
            code: '041',
            display: 'Church of Jesus Christ of Latter Day Saints (Mormons)'
          },
          { code: '042', display: 'Churches of Christ' },
          { code: '043', display: 'Disciples of Christ' },
          { code: '044', display: "Jehovah's Witness" },
          { code: '045', display: 'Seventh Day Adventist' },
          { code: '046', display: 'Presbyterian Church In Ireland' },
          { code: '047', display: 'Church of Ireland' },
          { code: '048', display: 'Agape' },
          { code: '049', display: 'Amish' },
          { code: '051', display: 'Belfast Chinese Christian Church' },
          { code: '052', display: 'Bible Pattern Church' },
          { code: '053', display: 'Brethren' },
          { code: '054', display: 'Brethren In Christ' },
          { code: '055', display: 'British Israelite' },
          { code: '056', display: 'Church of Scotland' },
          { code: '057', display: 'Chapel' },
          { code: '058', display: 'Church In Wales' },
          { code: '059', display: 'Charismatic' },
          { code: '060', display: 'Child of God' },
          { code: '061', display: 'Chinese Church' },
          { code: '062', display: 'Christian Fellowship' },
          { code: '063', display: 'Christian Fellowship Church' },
          { code: '064', display: 'Christian Scientist' },
          { code: '065', display: 'Church' },
          { code: '069', display: 'Church of the Nazarene' },
          { code: '070', display: 'Church on the Way' },
          { code: '071', display: 'City Mission' },
          { code: '073', display: 'Congregational Church' },
          { code: '074', display: 'Cooneyite' },
          { code: '075', display: 'Dutch Reformed Church' },
          { code: '076', display: 'Ecumenical' },
          { code: '077', display: 'Emmanuel Mission' },
          { code: '078', display: 'Episcopalian' },
          { code: '079', display: 'Evangelical' },
          { code: '080', display: 'Evangelical Alliance' },
          { code: '081', display: 'Evangelical Presbyterian Church' },
          { code: '082', display: 'Evangelical Union' },
          { code: '083', display: 'Faith Mission' },
          {
            code: '084',
            display: 'Fellowship of Independent Evangelical Churches'
          },
          { code: '085', display: 'Full Gospel Assembly' },
          { code: '086', display: 'House Church' },
          { code: '087', display: 'Independent' },
          { code: '088', display: 'Independent Evangelist' },
          { code: '089', display: 'Interdenominational' },
          { code: '090', display: 'Lutheran' },
          { code: '091', display: 'Mennonite' },
          { code: '092', display: 'Metropolitan Church' },
          { code: '093', display: 'Moravian' },
          { code: '094', display: 'Nonconformist' },
          { code: '095', display: 'Non Denominational' },
          { code: '096', display: 'Non-Subscribing Presbyterian' },
          { code: '097', display: 'Presbyterian' },
          { code: '098', display: 'Presbyterian Apostolic' },
          { code: '099', display: 'Presbyterian Church In Wales' },
          { code: '100', display: 'Presbyterian Secession Church' },
          { code: '101', display: 'Protestant' },
          { code: '102', display: 'Reformed' },
          { code: '103', display: 'Reformed Presbyterian' },
          { code: '104', display: 'Religious Society of Friends (Quakers)' },
          { code: '105', display: 'Scottish Episcopal Church' },
          { code: '106', display: 'Unitarian' },
          { code: '107', display: 'United Brethren' },
          { code: '108', display: 'United Church of Canada' },
          { code: '109', display: 'Unsectarian' },
          { code: '110', display: 'Whitewell Metropolitan Tabernacle' },
          { code: '111', display: 'Celtic Christian' },
          { code: '112', display: 'Day Church of God' },
          { code: '113', display: 'Church of Harmony' },
          { code: '114', display: 'Scottish Presbyterian' },
          { code: '115', display: 'Church of the Living' },
          { code: '116', display: 'Christian Spiritualist Church' },
          { code: '117', display: 'Ratana Church of New Zealand' },
          { code: '118', display: 'Green Pastures' },
          { code: '200', display: 'Christian' },
          { code: '201', display: 'Christian - Other' },
          { code: '209', display: 'Protestant (Mixed)' },
          { code: '210', display: 'Mixed Catholic/Protestant' },
          { code: '300', display: 'Buddhist' },
          { code: '301', display: 'Hindu' },
          { code: '305', display: 'Raja Yoga' },
          {
            code: '306',
            display: 'International Society For Krishna Consciousness'
          },
          { code: '302', display: 'Muslim' },
          { code: '303', display: 'Sikh' },
          { code: '304', display: 'Jewish' },
          { code: '307', display: 'Haredi' },
          { code: '400', display: 'Pagan' },
          { code: '401', display: 'Wicca' },
          { code: '402', display: 'Witchcraft' },
          { code: '403', display: 'Druid' },
          { code: '404', display: 'New Age' },
          { code: '405', display: 'Occult' },
          { code: '406', display: 'Shamanism' },
          { code: '407', display: 'Thelemite' },
          { code: '408', display: 'Reconstructionist' },
          { code: '409', display: 'Heathen' },
          { code: '500', display: 'Believe in God' },
          { code: '501', display: 'Monk' },
          { code: '502', display: 'Unification Church' },
          { code: '503', display: 'Vodun' },
          { code: '504', display: "Baha ' I" },
          { code: '505', display: 'Brahma Kumari' },
          { code: '506', display: 'Chinese Religion' },
          { code: '507', display: 'Confucianist' },
          { code: '508', display: 'Divine Lightmission' },
          { code: '509', display: 'Druze' },
          { code: '510', display: 'Eckankar' },
          { code: '511', display: 'Jain' },
          { code: '512', display: 'Mysticism' },
          { code: '513', display: 'Native American Church' },
          { code: '514', display: 'Own Belief System' },
          { code: '515', display: 'Deist' },
          { code: '516', display: 'Theism' },
          { code: '517', display: 'Ancestor Worship' },
          { code: '518', display: 'Pantheism' },
          { code: '519', display: 'Rastafarian' },
          { code: '520', display: 'Santeri' },
          { code: '521', display: 'Satanism' },
          { code: '522', display: 'Scientology' },
          { code: '523', display: 'Spiritualist' },
          { code: '524', display: 'Taoist' },
          { code: '525', display: 'Unitarian-Universalist' },
          { code: '526', display: 'Universalist' },
          { code: '527', display: 'Zoroastrian' },
          { code: '528', display: 'Sant Mat' },
          { code: '529', display: 'Tin Tao' },
          { code: '530', display: 'Church of All Religion' },
          { code: '531', display: 'Animism' },
          { code: '532', display: 'Free Church of Love' },
          { code: '540', display: 'Alevi' },
          { code: '700', display: 'Other Religions' },
          { code: '539', display: 'Yazidi' },
          { code: '533', display: 'Valmiki' },
          { code: '534', display: 'Ravidassia' },
          { code: '535', display: 'Mixed Religion' },
          { code: '536', display: 'Traditional African Religion' },
          { code: '537', display: 'Spiritual' },
          { code: '538', display: 'Shintoism' },
          { code: '600', display: 'Jedi Knight' },
          { code: '601', display: 'Atheist' },
          { code: '603', display: 'Humanist' },
          { code: '604', display: 'Free Thinker' },
          { code: '605', display: 'Rationalist' },
          { code: '606', display: 'Secularist' },
          { code: '607', display: 'Realist' },
          { code: '608', display: 'Agnostic' },
          { code: '609', display: 'Internationalist' },
          { code: '610', display: 'Bright' },
          { code: '611', display: 'Heavy Metal' },
          { code: '899', display: 'No Religion' },
          { code: '900', display: 'Not answered' },
          { code: '-1', display: 'Awaiting residual coding' },
          { code: '-6', display: 'Uncodeable text response' },
          { code: '-7', display: 'Failed multi tick' },
          { code: '-8', display: 'Code not required' },
          { code: '-9', display: 'Missing' }
        ]
      }
    ]
  },
  {
    key: 'hl7-v2-0006',
    label: 'HL7 Religion',
    publisher: 'HL7 International',
    sourceTitle: 'HL7 v2 table 0006 (Religion)',
    sourceUrl: 'https://terminology.hl7.org/CodeSystem-v2-0006.html',
    version: 'v2-0006',
    levels: [
      {
        key: 'broad',
        label: 'Top-level concepts',
        system: 'http://terminology.hl7.org/CodeSystem/v2-0006',
        concepts: [
          { code: 'AGN', display: 'Agnostic', group: 'Top-level' },
          { code: 'ATH', display: 'Atheist', group: 'Top-level' },
          { code: 'BAH', display: "Baha'i", group: 'Top-level' },
          { code: 'BRE', display: 'Brethren', group: 'Top-level' },
          { code: 'BUD', display: 'Buddhist', group: 'Top-level' },
          {
            code: 'CFR',
            display: 'Chinese Folk Religionist',
            group: 'Top-level'
          },
          { code: 'CHR', display: 'Christian', group: 'Top-level' },
          { code: 'CNF', display: 'Confucian', group: 'Top-level' },
          { code: 'DOC', display: 'Disciples of Christ', group: 'Top-level' },
          { code: 'ERL', display: 'Ethnic Religionist', group: 'Top-level' },
          { code: 'HIN', display: 'Hindu', group: 'Top-level' },
          { code: 'JAI', display: 'Jain', group: 'Top-level' },
          { code: 'JEW', display: 'Jewish', group: 'Top-level' },
          { code: 'MOS', display: 'Muslim', group: 'Top-level' },
          { code: 'NAM', display: 'Native American', group: 'Top-level' },
          { code: 'NRL', display: 'New Religionist', group: 'Top-level' },
          { code: 'NOE', display: 'Nonreligious', group: 'Top-level' },
          { code: 'SHN', display: 'Shintoist', group: 'Top-level' },
          { code: 'SIK', display: 'Sikh', group: 'Top-level' },
          { code: 'SPI', display: 'Spiritist', group: 'Top-level' },
          { code: 'OTH', display: 'Other', group: 'Top-level' },
          { code: 'VAR', display: 'Unknown', group: 'Top-level' }
        ]
      },
      {
        key: 'full',
        label: 'All concepts',
        system: 'http://terminology.hl7.org/CodeSystem/v2-0006',
        concepts: [
          { code: 'AGN', display: 'Agnostic', group: 'Top-level' },
          { code: 'ATH', display: 'Atheist', group: 'Top-level' },
          { code: 'BAH', display: "Baha'i", group: 'Top-level' },
          { code: 'BRE', display: 'Brethren', group: 'Top-level' },
          { code: 'BUD', display: 'Buddhist', group: 'Top-level' },
          {
            code: 'BMA',
            display: 'Buddhist: Mahayana',
            group: 'Buddhist',
            parent: 'BUD'
          },
          {
            code: 'BTH',
            display: 'Buddhist: Theravada',
            group: 'Buddhist',
            parent: 'BUD'
          },
          {
            code: 'BTA',
            display: 'Buddhist: Tantrayana',
            group: 'Buddhist',
            parent: 'BUD'
          },
          {
            code: 'BOT',
            display: 'Buddhist: Other',
            group: 'Buddhist',
            parent: 'BUD'
          },
          {
            code: 'CFR',
            display: 'Chinese Folk Religionist',
            group: 'Top-level'
          },
          { code: 'CHR', display: 'Christian', group: 'Top-level' },
          {
            code: 'ABC',
            display: 'Christian: American Baptist Church',
            group: 'Christian',
            parent: 'CHR'
          },
          {
            code: 'AMT',
            display: 'Christian: African Methodist Episcopal',
            group: 'Christian',
            parent: 'CHR'
          },
          {
            code: 'AME',
            display: 'Christian: African Methodist Episcopal Zion',
            group: 'Christian',
            parent: 'CHR'
          },
          {
            code: 'ANG',
            display: 'Christian: Anglican',
            group: 'Christian',
            parent: 'CHR'
          },
          {
            code: 'AOG',
            display: 'Christian: Assembly of God',
            group: 'Christian',
            parent: 'CHR'
          },
          {
            code: 'BAP',
            display: 'Christian: Baptist',
            group: 'Christian',
            parent: 'CHR'
          },
          {
            code: 'CRR',
            display: 'Christian: Christian Reformed',
            group: 'Christian',
            parent: 'CHR'
          },
          {
            code: 'CHS',
            display: 'Christian: Christian Science',
            group: 'Christian',
            parent: 'CHR'
          },
          {
            code: 'CMA',
            display: 'Christian: Christian Missionary Alliance',
            group: 'Christian',
            parent: 'CHR'
          },
          {
            code: 'COC',
            display: 'Christian: Church of Christ',
            group: 'Christian',
            parent: 'CHR'
          },
          {
            code: 'COG',
            display: 'Christian: Church of God',
            group: 'Christian',
            parent: 'CHR'
          },
          {
            code: 'COI',
            display: 'Christian: Church of God in Christ',
            group: 'Christian',
            parent: 'CHR'
          },
          {
            code: 'COM',
            display: 'Christian: Community',
            group: 'Christian',
            parent: 'CHR'
          },
          {
            code: 'COL',
            display: 'Christian: Congregational',
            group: 'Christian',
            parent: 'CHR'
          },
          {
            code: 'EOT',
            display: 'Christian: Eastern Orthodox',
            group: 'Christian',
            parent: 'CHR'
          },
          {
            code: 'EVC',
            display: 'Christian: Evangelical Church',
            group: 'Christian',
            parent: 'CHR'
          },
          {
            code: 'EPI',
            display: 'Christian: Episcopalian',
            group: 'Christian',
            parent: 'CHR'
          },
          {
            code: 'FWB',
            display: 'Christian: Free Will Baptist',
            group: 'Christian',
            parent: 'CHR'
          },
          {
            code: 'FRQ',
            display: 'Christian: Friends',
            group: 'Christian',
            parent: 'CHR'
          },
          {
            code: 'FUL',
            display: 'Christian: Full Gospel',
            group: 'Christian',
            parent: 'CHR'
          },
          {
            code: 'GRE',
            display: 'Christian: Greek Orthodox',
            group: 'Christian',
            parent: 'CHR'
          },
          {
            code: 'JWN',
            display: "Christian: Jehovah's Witness",
            group: 'Christian',
            parent: 'CHR'
          },
          {
            code: 'MOM',
            display: 'Christian: Latter-day Saints',
            group: 'Christian',
            parent: 'CHR'
          },
          {
            code: 'LUT',
            display: 'Christian: Lutheran',
            group: 'Christian',
            parent: 'CHR'
          },
          {
            code: 'LMS',
            display: 'Christian: Lutheran Missouri Synod',
            group: 'Christian',
            parent: 'CHR'
          },
          {
            code: 'MEN',
            display: 'Christian: Mennonite',
            group: 'Christian',
            parent: 'CHR'
          },
          {
            code: 'MET',
            display: 'Christian: Methodist',
            group: 'Christian',
            parent: 'CHR'
          },
          {
            code: 'NAZ',
            display: 'Christian: Church of the Nazarene',
            group: 'Christian',
            parent: 'CHR'
          },
          {
            code: 'ORT',
            display: 'Christian: Orthodox',
            group: 'Christian',
            parent: 'CHR'
          },
          {
            code: 'PEN',
            display: 'Christian: Pentecostal',
            group: 'Christian',
            parent: 'CHR'
          },
          {
            code: 'COP',
            display: 'Christian: Other Pentecostal',
            group: 'Christian',
            parent: 'CHR'
          },
          {
            code: 'PRE',
            display: 'Christian: Presbyterian',
            group: 'Christian',
            parent: 'CHR'
          },
          {
            code: 'PRO',
            display: 'Christian: Protestant',
            group: 'Christian',
            parent: 'CHR'
          },
          {
            code: 'PRC',
            display: 'Christian: Other Protestant',
            group: 'Christian',
            parent: 'CHR'
          },
          {
            code: 'REC',
            display: 'Christian: Reformed Church',
            group: 'Christian',
            parent: 'CHR'
          },
          {
            code: 'REO',
            display: 'Christian: Reorganized Church of Jesus Christ-LDS',
            group: 'Christian',
            parent: 'CHR'
          },
          {
            code: 'CAT',
            display: 'Christian: Roman Catholic',
            group: 'Christian',
            parent: 'CHR'
          },
          {
            code: 'SAA',
            display: 'Christian: Salvation Army',
            group: 'Christian',
            parent: 'CHR'
          },
          {
            code: 'SEV',
            display: 'Christian: Seventh Day Adventist',
            group: 'Christian',
            parent: 'CHR'
          },
          {
            code: 'SOU',
            display: 'Christian: Southern Baptist',
            group: 'Christian',
            parent: 'CHR'
          },
          {
            code: 'UCC',
            display: 'Christian: United Church of Christ',
            group: 'Christian',
            parent: 'CHR'
          },
          {
            code: 'UMD',
            display: 'Christian: United Methodist',
            group: 'Christian',
            parent: 'CHR'
          },
          {
            code: 'UNI',
            display: 'Christian: Unitarian',
            group: 'Christian',
            parent: 'CHR'
          },
          {
            code: 'UNU',
            display: 'Christian: Unitarian Universalist',
            group: 'Christian',
            parent: 'CHR'
          },
          {
            code: 'WES',
            display: 'Christian: Wesleyan',
            group: 'Christian',
            parent: 'CHR'
          },
          {
            code: 'WMC',
            display: 'Christian: Wesleyan Methodist',
            group: 'Christian',
            parent: 'CHR'
          },
          {
            code: 'COT',
            display: 'Christian: Other',
            group: 'Christian',
            parent: 'CHR'
          },
          { code: 'CNF', display: 'Confucian', group: 'Top-level' },
          { code: 'DOC', display: 'Disciples of Christ', group: 'Top-level' },
          { code: 'ERL', display: 'Ethnic Religionist', group: 'Top-level' },
          { code: 'HIN', display: 'Hindu', group: 'Top-level' },
          {
            code: 'HSH',
            display: 'Hindu: Shaivites',
            group: 'Hindu',
            parent: 'HIN'
          },
          {
            code: 'HVA',
            display: 'Hindu: Vaishnavites',
            group: 'Hindu',
            parent: 'HIN'
          },
          {
            code: 'HOT',
            display: 'Hindu: Other',
            group: 'Hindu',
            parent: 'HIN'
          },
          { code: 'JAI', display: 'Jain', group: 'Top-level' },
          { code: 'JEW', display: 'Jewish', group: 'Top-level' },
          {
            code: 'JCO',
            display: 'Jewish: Conservative',
            group: 'Jewish',
            parent: 'JEW'
          },
          {
            code: 'JOR',
            display: 'Jewish: Orthodox',
            group: 'Jewish',
            parent: 'JEW'
          },
          {
            code: 'JRC',
            display: 'Jewish: Reconstructionist',
            group: 'Jewish',
            parent: 'JEW'
          },
          {
            code: 'JRF',
            display: 'Jewish: Reform',
            group: 'Jewish',
            parent: 'JEW'
          },
          {
            code: 'JRN',
            display: 'Jewish: Renewal',
            group: 'Jewish',
            parent: 'JEW'
          },
          {
            code: 'JOT',
            display: 'Jewish: Other',
            group: 'Jewish',
            parent: 'JEW'
          },
          { code: 'MOS', display: 'Muslim', group: 'Top-level' },
          {
            code: 'MSH',
            display: 'Muslim: Shiite',
            group: 'Muslim',
            parent: 'MOS'
          },
          {
            code: 'MSU',
            display: 'Muslim: Sunni',
            group: 'Muslim',
            parent: 'MOS'
          },
          {
            code: 'MOT',
            display: 'Muslim: Other',
            group: 'Muslim',
            parent: 'MOS'
          },
          { code: 'NAM', display: 'Native American', group: 'Top-level' },
          { code: 'NRL', display: 'New Religionist', group: 'Top-level' },
          { code: 'NOE', display: 'Nonreligious', group: 'Top-level' },
          { code: 'SHN', display: 'Shintoist', group: 'Top-level' },
          { code: 'SIK', display: 'Sikh', group: 'Top-level' },
          { code: 'SPI', display: 'Spiritist', group: 'Top-level' },
          { code: 'OTH', display: 'Other', group: 'Top-level' },
          { code: 'VAR', display: 'Unknown', group: 'Top-level' }
        ]
      }
    ]
  }
];

export const DEFAULT_RELIGION_CLASSIFICATION = 'abs-ascrg';
export const DEFAULT_RELIGION_LEVEL = 'narrow';
